import Auth from '../Auth'
import Model from './Model'

import Team from './Team'
import ProjectPosition from './ProjectPosition'

import {BiddingWizard} from '../views/project-bidding/BiddingWizard'
import BiddingProposalsStep from './../views/project-bidding/BiddingProposalsStep'
import BiddingContractStep from './../views/project-bidding/BiddingContractStep'

import ProjectBiddingContractDeliverablesSubstep from './../views/project-bidding/BiddingContractDeliverablesSubstep'
import ProjectBiddingContractScheduleSubstep from './../views/project-bidding/BiddingContractScheduleSubstep'
import ProjectBiddingContractFeesSubstep from './../views/project-bidding/BiddingContractFeesSubstep'
import HasProjectSteps from "./decorators/HasProjectSteps";
import HasRequiredExperience from './decorators/HasRequiredExperience'
import BiddingCandidatesStep from "../views/project-bidding/BiddingCandidatesStep";
import ReviewStep from "../views/create-project/steps/ReviewStep";
import User from "./User";
import BiddingBriefStep from "../views/project-bidding/BiddingBriefStep";
import {generatePath, Link} from "react-router-dom";
import React from "react";
import ProjectGroup from "./ProjectGroup";
import BiddingContractContactDetailsSubstep from "../views/project-bidding/BiddingContractContactDetailsSubstep";
import Document from "./Document";
import BiddingContractSummarySubstep from "../views/project-bidding/BiddingContractSummarySubstep";
import BiddingContractApprovalDocumentsSubstep from "../views/project-bidding/BiddingContractApprovalDocumentsSubstep";
import TalentCandidate from "./TalentCandidate";
import ProjectPhase from "./ProjectPhase";
import Opportunity from "./Opportunity";
import BiddingContractTeamMembersSubstep from "./../views/project-bidding/BiddingContractTeamMembersSubstep";
import ChangeOrder from "./ChangeOrder";

const ContractType = {
    FixedFee: 'Fixed Fee',
    FixedRetainer: 'Fixed Retainer',
    TimeMaterials: 'Time & Materials',
}

const ProjectType = {
    Service: 'Service-Based',
    BYO: 'Build Your Own',
}

const ProjectCandidateStatus = {
    StatusUninvited:  'Not Invited',
    StatusPendingInvite:  'Notified.  No Response Yet',
    StatusApproved:  'Interested!',
    StatusRejected:  'Not Interested',
    StatusWithdrawn:  'Withdrew Interest',
    StatusScopeOutlined: 'Has Outlined Scope',
    StatusQuoteConfirmed: 'Has Confirmed Quote',
}

const ProjectStatus = {
    New: 'New',
    PendingScope: 'Pending Scope',
    SelectingTalent: 'Selecting Talent',
    AcceptingProposals: 'Accepting Proposals',
    AwaitingContract: 'Awaiting Contract',
    PendingContract: 'Pending Contract',
    PendingKickoff: 'Pending Kickoff',
    Active: 'Active',
    Complete: 'Complete',
    Cancelled: 'Cancelled',
}
const ProjectSections = {
    SectionType: 'Project Type',
    SectionProfile: 'Project Profile',
    SectionScopeSettings: 'Project Scope',
    SectionServiceDeliverables: 'Deliverables',
    SectionServiceDisciplinesSkills: 'Roles & Skills',
    SectionServiceSkillsIndustries: 'Skills & Industry',
    SectionServiceSkills: 'Skills',
    SectionServiceIndustries: 'Industry',
    SectionServiceExperience: 'Years Experience',
    SectionPositions: 'Project Roles',
    SectionReview: 'Summary'
}

const ContractManagementSettings = {
    ApprovedOnline: 1,
    ApprovedOffline: 2,
    NoSow: 3,
}
const VisibilityDefaultSettings = [
    {
        id: -1,
        label: "Talent I've Favorited On Wripple",
        key: 'visibility_setting_favorites'
    },
    {
        id: -2,
        label: "Past Hires I've Worked with",
        key: 'visibility_setting_hired'
    },
    {
        id: -3,
        label: "Talent Invited Through My Company Network",
        key: 'visibility_setting_invited'
    }
]
export default class Project extends HasRequiredExperience(
    HasProjectSteps(
        Model
    )
) {
    static Key = 'Project';

    static ProjectSections = ProjectSections;
    static ProjectType = ProjectType;
    static ContractSettings = ContractManagementSettings;
    static VisibilityDefaultSettings = VisibilityDefaultSettings;

    resolve() {
        if (!this.positions_count && this.isBYO()) {
            // this.positions_count = 1;
        }
        // if (this.positions_count) {
        this.positions = this.resolvePositions(this.positions);
        // }
        return this;
    }

    detailLink() {

        if (this.isNew()) {
            let step = this.currentStep();

            return step.getPath(this);
        }

        if (this.isSelectingTalent() || this.isPendingScope()) {
            if (!this.limited && this.hasInvalidPositions()) {
                let step = this.currentStep();

                return step.getPath(this);
            }
            if (this.isBYO()
                && this.hasAnyCandidatesForAnyPositions()
                && TB.auth().user()?.canViewTalentForProject(this)
            ) {
                return BiddingWizard.pathFor(
                    this, BiddingCandidatesStep.slug
                );
            }

            if (!TB.auth().user()?.canViewTalentForProject(this)) {
                return BiddingWizard.pathFor(
                    this, BiddingBriefStep.slug
                );
            }
            return BiddingWizard.defaultPath(
                this
            );
        }

        if (this.isPendingContract()) {
            if (!TB.auth().user()?.canViewSOWForProject(this)) {
                if (!TB.auth().user()?.canViewTalentForProject(this)) {
                    return BiddingWizard.pathFor(
                        this, BiddingBriefStep.slug
                    );
                }
                return BiddingWizard.pathFor(
                    this, this.isBYO() ? BiddingCandidatesStep.slug : BiddingProposalsStep.slug
                );
            }

            return BiddingWizard.pathFor(
                this, BiddingContractStep.slug
            );
        }


        if (this.isAcceptingProposals() || this.isAwaitingContract()) {
            if (!TB.auth().user()?.canViewTalentForProject(this)) {
                return BiddingWizard.pathFor(
                    this, BiddingBriefStep.slug
                );
            }


            return BiddingWizard.pathFor(
                this, this.isBYO() ? BiddingCandidatesStep.slug : BiddingProposalsStep.slug
            );
        }

        return `/client/project/active/${this.id}`
    }

    briefStep(params) {
        if (params) {
            return {
                ...params,
                pathname: BiddingWizard.pathFor(
                    this, BiddingBriefStep.slug
                )
            }
        }
        return BiddingWizard.pathFor(
            this, BiddingBriefStep.slug
        );
    }

    canViewTeams() {
        if (this.isBidding()) {
            return true;
        }

        if (!this.isNew()) {
            return false;
        }

        let createStep = this.currentStep()
        if (!createStep) {
            return true;
        }

        if (!createStep.optional) {
            return false;
        }
    }

    canEditScope() {
        // if (this.isBYO()) {
        // 	return this.isNew();
        // }

        return !this.is_on_hold && this.isNew()
            || this.isSelectingTalent()
            || this.isAcceptingProposals();
    }

    // editScopeLink() {
    //     if (!this.canEditScope()) {
    //         return this.reviewLink();
    //     }
    //     let steps = this.currentSteps();
    //
    //     let scopeStep = TB.find([...steps], step => step.prototype instanceof ScopeStep);
    //
    //     return scopeStep
    //         ? scopeStep.getPath(this)
    //         : generatePath(TB.routes().clientProjectSetup, {
    //             projectId: this.id
    //         });
    // }

    reviewLink() {
        return ReviewStep.getPath(this);
    }

    /*
    |--------------------------------------------------------------------------
    | Contract Type
    |--------------------------------------------------------------------------
    */

    static ContractType = ContractType;

    static contractTypeNameFor(contractType) {
        if (!contractType) {
            return;
        }

        return laravel.project_contract_types[contractType];
    }

    contractTypeName() {
        return this.constructor.contractTypeNameFor(
            this.contract_type
        );
    }


    isFixedRetainer() {
        return this.contractTypeName() === ContractType.FixedRetainer;
    }

    isFixedFee() {
        return this.contractTypeName() === ContractType.FixedFee;
    }

    isTimeMaterials() {
        return this.contractTypeName() === ContractType.TimeMaterials;
    }

    /*
    |--------------------------------------------------------------------------
    | Project Type
    |--------------------------------------------------------------------------
    */

    static Type = ProjectType;

    static typeNameFor(projectType) {
        if (!projectType) {
            return;
        }

        return laravel.project_types[projectType];
    }

    typeName() {
        return this.constructor.typeNameFor(
            this.type
        );
    }

    static isServiceType(typeName) {
        return typeName === ProjectType.Service;
    }

    isService() {
        return this.constructor.isServiceType(
            this.typeName()
        );
    }

    normalizeScopeForService = () => {

        let normalize = [...(this.phases || [])];

        let disciplines = TB.map(this.disciplines, (discipline, dIndex) => {
            let talent_opp = this.assigned_team_candidate && TB.find(this.assigned_team_candidate.talent_opps, opp => {
                return opp.status !== Opportunity.Statuses.Lost && TB.find(opp.disciplines, {id: discipline.id})
            });

            // console.log('talent_opps', talent_opp);
            // talent_opp = TB.first(TB.shuffle(talent_opp))
            if (talent_opp) {
                let talentDiscipline = TB.find(talent_opp.disciplines, ['id', discipline.id]) || {};

                talent_opp = {
                    ...talent_opp,
                    opp_discipline: talentDiscipline,
                    discipline_index: discipline.display_index,
                }
            }

            return {
                ...discipline,
                team_discipline_index: dIndex + 1,
                talent_opp,
                estimated_team_cost: talent_opp?.opp_discipline?.payout_amount || 0,
                estimated_platform_cost: talent_opp?.opp_discipline?.platform_cost || 0,
                total_team_hours: talent_opp?.opp_discipline?.total_hours || 0,
                market_rate: talent_opp?.opp_discipline?.hourly_rate || 0
            }
        })

        normalize = TB.orderBy(normalize, ['display_index', p => !!p.display_index], ['asc', 'desc']);

        let phases = TB.map(normalize, (phase, pIndex) => {

            let phaseModel = ProjectPhase.make({...phase, percent_markup: this.percent_markup});

            let activeDeliverables = TB.filter(phaseModel.deliverables, ['is_active', true])
            let total_hours = TB.sumBy(activeDeliverables, 'total_hours');
            let estimated_cost = TB.sumBy(activeDeliverables, 'estimated_cost');

            let display_index = pIndex + 1

            return ProjectPhase.make({...phaseModel, estimated_cost, total_hours, display_index, percent_markup: this.percent_markup})
        });

        return {phases, disciplines,assumptions: this.assumptions, percent_markup: this.percent_markup}
    }

    static isBYOType(typeName) {
        return typeName === ProjectType.BYO;
    }

    isBYO() {
        return this.constructor.isBYOType(
            this.typeName()
        );
    }

    talentMatchType() {
        if (this.isService()) {
            return Team;
        }

        if (this.isBYO()) {
            return TalentCandidate;
        }
    }

    /*
    |--------------------------------------------------------------------------
    | Details
    |--------------------------------------------------------------------------
    */

    clientProjectGroup() {
        if (!this.client_project_group) {
            return false;
        }

        let group = {...(this.client_project_group || {})};

        if (!!this.client_project_group_id && !this.client_project_group?.id) {
            let groups = TB.auth().user().client_project_groups;
            if (!groups?.length) {
                return false;
            }

            group = TB.find(groups, ['id', parseInt(this.client_project_group_id)])

            if (!group) return false;
        }

        return ProjectGroup.make(group)
    }

    clientOwner() {
        if (!this.assigned_users?.length) {
            return false
        }
        return TB.find(this.assigned_users, ['is_owner', true])
    }

    hasValueForProp(prop) {
        switch (prop) {
            case 'start_range':
            case 'time_range':
                return !isNaN(parseInt(this.start_range));
            case 'location':
                return TB.isObject(this.location);
            case 'is_managed':
                return TB.isBoolean(this.is_managed)
                    || !isNaN(parseInt(this.is_managed));
            case 'budgets':
                return this.hasBudgetRange();
            default:
                return this.hasOwnProperty(prop)
                    && this[prop] !== undefined
                    && this[prop] !== null;
        }
    }

    formattedValueForProp(prop) {
        if (!this.hasValueForProp(prop)) {
            return '---';
        }

        switch (prop) {
            case 'start_range':
                return this.startRangeName();
            case 'time_range':
                return this.timeRangeName();
            case 'location':
                return this.location.full;
            case 'allow_remote_team':
                return this.allow_remote_team ? 'Yes' : 'No';
            case 'is_managed':
                return this.is_managed ? laravel.platform_name : 'Client';
            case 'budgets':
                return this.budgetRange();
            default:
                return this[prop];
        }
    }

    invoiceTerms() {
        return 'Net 30';
    }

    managingOrgName() {
        if (!TB.isBoolean(this.is_managed)) {
            return '---';
        }

        if (this.is_managed) {
            return TB.config('app.name');
        }

        let auth = TB.auth().user(),
            client = auth ? auth.clientOrg() : null;
        if (!client) {
            return '---';
        }

        return client.name;
    }

    /*
    |--------------------------------------------------------------------------
    | Cost Calculations
    |--------------------------------------------------------------------------
    */

    hasBudget() {
        return this.min_budget || this.max_budget;
    }

    hasBudgetRange() {
        return TB.isDefined(this.min_budget) && TB.isDefined(this.max_budget);
    }

    budgetRange() {
        if (!this.min_budget && !this.max_budget) {
            return '---';
        }

        if (!this.min_budget && this.max_budget) {
            return TB.formatCurrency(this.max_budget);
        }

        if (this.min_budget && !this.max_budget) {
            return TB.formatCurrency(this.min_budget);
        }

        return `${TB.formatCurrency(this.min_budget)} - ${TB.formatCurrency(this.max_budget)}`;
    }

    shortEstimate() {
        if (!this.hasEstimate()) {
            return '---';
        }

        return TB.formatCurrency(this.platform_cost)
    }

    hasEstimate() {
        return !TB.isNaN(parseInt(this.platform_cost));
    }

    disciplineLookup() {
        if (!this.disciplines) {
            return;
        }

        return TB.keyBy(this.disciplines, 'id');
    }

    /*
    |--------------------------------------------------------------------------
    | Scoping
    |--------------------------------------------------------------------------
    */

    confirmScopingCallRequest() {
        let consultantName = TB.auth().user()?.clientOrg()?.consultant?.firstNamePlusInitial();
        if (!consultantName) {
            consultantName = TB.auth().user()?.firstNamePlusInitial();
        }
        return TB.alert("confirm", "Schedule Scoping Call with your Client Lead",
            `Click submit to request a scoping call with your Client Lead. ${consultantName} will reach out shortly via email to schedule your call so we can best fit your project needs`,
            [
                {title: 'Submit'},
                {title: 'Cancel'}
            ]
        )
    }

    async canShortlistCandidates() {
        const candidateType = this.isBYO() ? "candidates" : "teams"
        if (this.isFixedFee() && !this.hasConfirmedProjectScope()) {
            if (this.hasCompletedProjectScopeCall()) {
                await TB.alert("warning", "Final Scope Still Pending",
                    `Your client lead is still finalizing the scope. You will receive a notification when ready allowing you to invite ${candidateType} to propose.`)
                return false;
            }else if(this.hasRequestedProjectScopeCall()) {
                await TB.alert("warning", "Scoping Call Pending", "Your client lead will reach out shortly via email to schedule your call.")
                return false;
            }else {
                await TB.alert("warning", "Scoping Call Required", `You must schedule a scoping call with your client lead before inviting ${candidateType} to propose.`)
                return false;
            }
        }
        return true;
    }

    hasConfirmedProjectScope() {
        return !this.isFixedFee() || this.has_confirmed_scope
    }

    hasRequestedProjectScopeCall() {
        return !this.isFixedFee() || this.scope_call_requested_at
    }

    hasCompletedProjectScopeCall() {
        return this.hasRequestedProjectScopeCall() && this.scope_call_logged_at
    }

    estimatedCostRangeForService() {
        let range = '$';
        if (this.template.ballpark_min) {
            range += TB.formatNumber(this.template.ballpark_min, 0)
        }
        if (this.template.ballpark_min && this.template.ballpark_max) {
            range += '-'
        }
        if (this.template.ballpark_max) {
            range += TB.formatNumber(this.template.ballpark_max, 0)
        }
        return range;
    }

    /*
    |--------------------------------------------------------------------------
    | Positions (For BYO)
    |--------------------------------------------------------------------------
    */

    static maxAllowedPositions() {
        return parseInt(laravel.platform_settings.Max_Roles_Per_BYO_Project);
    }

    canAddPositions() {
        if (!this.isBYO()
            // || this.hasRequestedProposal()
            || this.hasRequestedSOW()) {
            return false;
        }

        return this.sortedPositions().length < this.constructor.maxAllowedPositions();
    }

    pathForNewPosition() {
        return generatePath('/client/project/setup/:projectId/role/new', {
            projectId: this.id
        })
    }
    static minRequiredPositions() {
        return 1;
    }

    canDeletePositions() {
        if (this.hasRequestedSOW()) {
            return false;
        }

        return this.sortedPositions().length > this.constructor.minRequiredPositions();
    }

    canDeletePosition(position) {
        return this.canDeletePositions();
    }

    async confirmDeletePosition(position) {
        return new Promise(async (resolve, reject) => {

            let shouldDelete = false;
            if (position.upcoming_meetings_count > 0 ||  position.proposed_meetings_count > 0) {
                shouldDelete = await TB.sysAlert('client.pending_interview_cancellation_on_delete_role');
            }else {
                shouldDelete = await TB.sysAlert('byo.delete_role_button_clicked');
            }

            if (shouldDelete) {
                let updatedProject = await this.deletePosition(
                    position
                ).catch(reject)

                resolve(updatedProject);
            } else resolve();
        });
    }

    async deletePosition(position) {
        let positions = TB.filter([...this.positions], ({id}) => id !== position.id);


        this.positions = this.resolvePositions(
            positions
        );

        this.positions = this.resolveSortOrderForPositions(
            positions
        );

        this.positions_count = this.positions.length;

        let positions_count = this.positions_count;

        return this.sync();
    }

    sortedPositions(clearInvalid = false) {
        if (clearInvalid) {
            let positions = ProjectPosition.makeMany([...this.positions]);
            let valid = [];
            for (let position of positions) {
                if (!position.needsSetup()) {
                    position.display_index = valid.length;
                    valid.push(position);
                }
            }
            // console.log('sortedPositions -> valid', valid);
            this.positions = [...valid]
            if (this.positions_count < this.positions.length) {
                this.positions_count = this.positions.length;
            }
        }

        return this.positions || [];
    }

    visiblePositions() {
        return TB.filter(this.sortedPositions(), ['is_visible', true])
    }

    hasSetupAPosition() {
        if (!this.positions_count) {
            return false;
        }

        let positions = this.sortedPositions();
        for (let position of positions) {
            if (position.needsSetup()) {
                return true;
            }
        }

        return false;
    }

    hasAnyCandidatesForAnyPositions() {
        if (!this.positions_count) {
            return false;
        }

        let positions = this.sortedPositions();
        // console.log('hasAnyCandidatesForAnyPositions', positions)
        for (let position of positions) {
            if (position.has_candidates) {
                return true;
            }
        }

        return false;
    }

    hasCandidatesForAllPositions() {
        if (!this.positions_count) {
            return false;
        }

        let positions = this.sortedPositions();
        for (let position of positions) {
            if (!position.has_candidates) {
                return false;
            }
        }

        return true;
    }
    hasInvalidPositions() {
        if (this.isPendingContract() || this.isAwaitingContract() || this.isActive()) {
            return false;
        }
        if (!this.positions_count) {
            return false;
        }

        let positions = this.sortedPositions();
        for (let position of positions) {
            if (position.id && position.needsSetup()) {
                return true;
            }
        }

        return false;
    }
    hasSetupAllPositions() {
        if (!this.positions_count) {
            return false;
        }

        let positions = this.sortedPositions();
        for (let position of positions) {
            if (position.needsSetup() && !position.hasBeenFilled()) {
                return false;
            }
        }

        return true;
    }

    hasFilledAPosition() {
        if (!this.hasSetupAllPositions()) {
            return false;
        }

        let positions = this.sortedPositions();
        for (let i in positions) {
            if (positions[i].hasBeenFilled()) {
                return true;
            }
        }

        return false;
    }

    hasFilledAllPositions() {
        if (!this.hasSetupAllPositions()) {
            return false;
        }

        let unfilledPosition = TB.find(this.sortedPositions(), pos => !pos.hasBeenFilled());

        return !unfilledPosition;
    }

    hasSetTaxClassificationForPositions() {
        if (!this.hasFilledAllPositions()) {
            return false;
        }
        return !TB.filter(this.sortedPositions(), pos => !pos?.hasCompletedTaxClassificationForCandidate())?.length
    }
    hasSetOfferingHireTypeForPositions() {
        if (!this.hasFilledAllPositions()) {
            return false;
        }
        return !TB.filter(this.sortedPositions(), pos => !pos?.offeringHireType())?.length
    }

    filledPositionCount() {
        return TB.filter(this.sortedPositions(), pos => pos.hasBeenFilled()).length;
    }

    indexOfFirstPositionNeedingSetup() {
        return TB.find(this.sortedPositions(), position => position.needsSetup())
    }

    firstPosition() {
        return TB.first(
            this.sortedPositions()
        );
    }

    previousPosition(display_index) {
        let currentIndex = this.positionIndex(display_index);

        if (!currentIndex) return null;

        return this.sortedPositions()[currentIndex - 1]
    }

    nextPosition(display_index) {
        let currentIndex = this.positionIndex(display_index);

        if (currentIndex === -1) return null;

        return this.sortedPositions()[currentIndex + 1]
    }

    positionIndex(display_index) {
        return TB.findIndex(this.sortedPositions(), ['display_index', display_index])
    }

    positionWithId(id) {
        return TB.find(this.positions, ['id', id]);
    }

    positionWithIndex(index) {
        if (!this.positions ||( this.positions.length - 1) < index) return;
        return TB.find(this.positions, position => {
            if (TB.isInteger(position.display_index)) {
                return position.display_index === parseInt(index)
            }
            return position.display_index === String(index)
        });
    }

    filterValidPositions(positions) {
        return TB.filter([...positions], ({title}) => {
            return TB.isString(title) && title.length > 0;
        });
    }

    resolveSortOrderForPositions(positions) {
        let sorted = TB.sortBy([...positions], 'display_index');
        let display;
        return sorted.map(pos => {
            if (!TB.isDefined(pos.display_index)) {
                pos.display_index = display + 1 || 0;
            } else pos.display_index = parseInt(pos.display_index);

            display = pos.display_index;

            return pos;
        });
    }

    resolvePositions(positions = this.positions) {
        positions = this.filterValidPositions(
            [...(positions || [])]
        );

        let display_index = this.nextPositionDisplayIndexFrom(positions);

        // if (this.positions_count > (positions.length + 1)) {
        //     this.positions_count = positions.length + 1;
        // }
        // while (positions.length < this.positions_count) {
        //     positions.push(
        //         this.newPosition({
        //             display_index
        //         })
        //     );
        //     display_index++;
        // }


        positions = TB.sortBy(
            this.resolveSortOrderForPositions(positions), 'display_index'
        )

        for (let position of positions) {
            if (!position.hasOwnProperty('is_visible')) {
                position.is_visible = true;
            }
        }


        return ProjectPosition.makeMany(
            [...positions]
        );
    }

    nextPositionDisplayIndexFrom(positions) {
        let sorted = this.resolveSortOrderForPositions(
            positions
        );

        let lastDisplayed = TB.maxBy(sorted, 'display_index');

        return lastDisplayed
            ? (lastDisplayed.display_index + 1)
            : 1;
    }

    newPosition(props = {}) {
        let startDate = this.anticipatedStart();
        let endDate = this.anticipatedEnd();
        let industries = this.industries;

        if (!industries?.length) {
            let auth = TB.auth().user();

            if (auth && auth.clientOrg() && auth.clientIndustry()) {
                industries = [
                    auth.clientIndustry()
                ]
            }
        }


        if (startDate && endDate && startDate.isSameOrAfter(endDate)) {
            endDate = null
        }
        let positionProps = {
            ...props,
            started_at: startDate ? startDate.toISOString() : null,
            ended_at: endDate ? endDate.toISOString() : null,
            industries,
            project_id: this.id,
            contract_type: this.contract_type
        };

        if (this.isFixedRetainer()) {
            positionProps.payout_frequency = 'weekly'
        }
        return ProjectPosition.make(positionProps);
    }

    /*
    |--------------------------------------------------------------------------
    | Network Requests
    |--------------------------------------------------------------------------
    */

    static CreateRequest;
    static SyncRequest;
    static FetchClientAllRequest;
    static FetchAllRequest;
    static FetchRequest;

    static adjustPropsOnFetched(props) {
        if (TB.isDefined(props.avg_onsite_days_per_week)) {
            props.requires_onsite_team = true;
        } else if (!TB.isDefined(props.requires_onsite_team)
            && (TB.isDefined(props.location) || TB.isDefined(props.allow_remote_team))) {
            props.requires_onsite_team = false;
        }

        return props;
    }

    static async fetchAllForClient(params = {}, refresh = false, requestOptions = {}) {
        let user = Auth.registeredClientUser();
        if (!user) {
            return;
        }

        if (!refresh && this.Cached && this.Cached.length) {
            return this.Cached;
        }
        let formattedParams = {};
        for (let [key, value] of Object.entries(params)) {
            if (TB.isArray(value)) {
                if (!value.length) {
                    continue;
                }
                value = value.join(',');
            }
            formattedParams[key] = value;
        }

        this.FetchClientAllRequest = TB.request(
            TB.api_endpoint(`/api/clients/${user.clientOrg().id}/projects`), formattedParams
        );

        let response = await this.FetchClientAllRequest.get(requestOptions).catch(console.warn);

        if (!response || !TB.has(response, 'success.data.projects')) {
            return false;
        }

        let projects = TB.map([...response.success.data.projects], project => {
            project.limited = true;
            return Project.adjustPropsOnFetched(project);
        })
        this.Cached = this.makeMany(
            projects
        );

        // for (let project of this.Cached) {
        // console.log(project.disciplineHourlyTotals());
        // console.log(project.schedule);
        // }

        return [...this.Cached];
    }

    static async cancelSearchKeywords() {
        if (this.SearchKeywordsRequest && !this.SearchKeywordsRequest.didFinish) {
            await this.SearchKeywordsRequest.cancel();
        }
    }

    static async searchKeywords(query, requestOptions = {}) {
        // this.cancelSearchKeywords();

        let user = Auth.registeredClientUser();
        if (!user) {
            return;
        }

        let params = {
            search: query
        };

        this.SearchKeywordsRequest = TB.request(
            TB.api_endpoint(`/api/projects/keywords/search`), params
        );

        let response = await this.SearchKeywordsRequest.get(requestOptions).catch(console.warn);


        if (!response || !TB.has(response, 'success.data.results')) {
            // let didHandleError = await this.SearchKeywordsRequest.handleError();
            // if (didHandleError
            //     && this.SearchKeywordsRequest.shouldRerun) {
            //     return this.searchKeywords(query);
            // }

            throw new Error('Something went wrong')
        }

        return [...response.success.data.results];
    }

    static FetchAllForClientManagerRequest;

    static async fetchAllForClientAdmin(params = {}, refresh = true) {
        // console.log('fetchAllForTalentManager');
        let user = Auth.registeredClientUser();
        if (!user || !user.canManageClients()) {
            return;
        }

        // if (this.Cached && this.Cached.length && !refresh) {
        //     return this.Cached;
        // }


        if (params.statuses) {
            let lookup = TB.values({...ProjectStatus});
            let actualStatuses = [];
            for (let index of params.statuses) {
                actualStatuses.push(laravel.project_status_scopes[lookup[index]]);
            }

            params.statuses = actualStatuses;
        }

        let formattedParams = {};
        for (let [key, value] of Object.entries(params)) {
            if (TB.isArray(value)) {
                if (!value.length) {
                    continue;
                }
                value = value.join(',');
            }
            formattedParams[key] = value;
        }

        await this.cancelRequest('FetchAllForClientManagerRequest')
        // console.log(formattedParams);
        this.FetchAllForClientManagerRequest = TB.request(
            TB.api_endpoint(`/api/projects`),
            formattedParams
        );

        let Request = this.FetchAllForClientManagerRequest;

        let response = await Request.get().catch(console.warn);

        if (Request.wasCancelled) {
            return;
        }

        if (!TB.has(response, 'success.data.projects')) {
            return TB.event("Project.ClientManager@FetchAllForClientManagerFailed", Request)
        }

        let {
            // projects,
            current_page,
            last_page,
            total
        } = response.success.data;

        let projects = TB.map([...response.success.data.projects], project => {
            project.limited = true;
            return Project.adjustPropsOnFetched(project);
        })

        let models = this.makeMany([...projects]);

        // let statusOptions = this.statusOptions();

        // models = TB.orderBy(
        //     models,
        //     project => statusOptions.indexOf(project.displayStatus()),
        //     'asc'
        // );

        if (params.page
            && params.page > 1
            && (this.Cached?.length + models.length) === (params.per_page * params.page)) {
            models = [
                ...this.Cached,
                ...models
            ];
        }

        this.Cached = models;

        TB.event(
            "Project.ClientManager@FetchAllForClientManagerUpdated",
            {
                models,
                current_page,
                last_page,
                total
            }
        )
    }


    /**
     * @param {number} projectId
     * @param refresh
     * @param requestOptions
     * @return {object} Project
     */
    static async fetchForClient(projectId, refresh = false, requestOptions = {}) {
        let user = Auth.registeredClientUser();
        if (!user) {

            console.log('Project @ fetchForClient -> no user');
            throw new Error("Unauthorized")
        }

        // let projects = [];
        // if (this.Cached && this.Cached.length) {
        //     projects = this.Cached;
        // }
        // else if (!this.Cached || !this.Cached.length) {
        // 	projects = await this.fetchAllForClient();
        // }

        // let lookup = TB.keyBy(projects, 'id');

        // let project = lookup[projectId];

        // if (!project || project.limited || refresh) {
        console.log('Project @ fetchForClient -> fetching....');
        // if(!project) {
        this.FetchRequest = TB.request(
            TB.api_endpoint(`/api/clients/${TB.auth().user().clientOrg().id}/projects/${projectId}`)
        );

        let response = await this.FetchRequest.get(requestOptions).catch(console.warn);

        if (!TB.has(response, 'success.data.project')) {
            console.log('Project @ fetchForClient -> no project on resp');
            throw new Error("Something went wrong")
        }

        let projectProps = Project.adjustPropsOnFetched({
            ...response.success.data.project,
            limited: false
        });
        let project = Project.make(projectProps);
        // console.log('Project @ fetchForClient -> project', project);

        await this.refreshCacheFor(
            project, 'Cached',true
        );

        // }

        return project;
    }

    static async getMatchingUserCountForPosition(projectId, positionId, visibilitySettings,requestOptions = {}) {
        let user = Auth.registeredClientUser();
        if (!user) {
            console.log('Project @ fetchForClient -> no user');
            throw new Error("Unauthorized")
        }

        let params = {}
        if (visibilitySettings) {

            console.log('getMatchingUserCountForPosition', visibilitySettings)
            if (visibilitySettings?.visibility_setting_location) {
                params.visibility_setting_location = parseInt(visibilitySettings?.visibility_setting_location);
                switch (parseInt(visibilitySettings?.visibility_setting_location)) {
                    case TB.locationRegionalSetting():
                        if(visibilitySettings?.visible_regions?.length) {
                            params.countries = TB.join(TB.flatMap(visibilitySettings?.visible_regions, 'countries'), ',');
                        }
                        if (!params.countries) {
                            params.countries = 'US'
                        }
                        break;
                    case TB.locationProximitySetting():
                        // if (visibilitySettings?.latitude) {
                        //     params.latitude = visibilitySettings.latitude;
                        //     params.longitude = visibilitySettings.longitude;
                        // }
                        break;
                    case TB.locationGlobalSetting():
                        // if (visibilitySettings?.latitude) {
                        //     params.latitude = visibilitySettings.latitude;
                        //     params.longitude = visibilitySettings.longitude;
                        // }
                        params.countries = [];
                        console.log('getMatchingUserCountForPosition', params)
                        break;
                }
            }
            if (visibilitySettings?.visibility_setting_hired) {
                params.hired = 1
            }
            if (visibilitySettings?.visibility_setting_invited) {
                params.invited = 1
            }
            if (visibilitySettings?.visibility_setting_favorites) {
                params.favorited = 1
            }

            if (visibilitySettings?.visible_talent_pools?.length) {
                params.pool_ids = TB.map(visibilitySettings?.visible_talent_pools,p => p.id).join(',');
            }
        }
        const getMatchingUserCountRequest = TB.request(
            TB.api_endpoint(`/api/clients/${TB.auth().user().clientOrg().id}/projects/${projectId}/positions/${positionId}/matching-talent-users-count`),
            params
        );

        let response = await getMatchingUserCountRequest.get(requestOptions).catch(console.warn);

        if (!TB.isDefined(response?.success?.data?.matches_total)) {
            throw new Error("Something went wrong")
        }

        return response.success.data
    }

    /*
    |--------------------------------------------------------------------------
    | Engagement Managers
    |--------------------------------------------------------------------------
    */

    /*
    |--------------------------------------------------------------------------
    | Network Requests - Engagement Managers
    |--------------------------------------------------------------------------
    */

    static IndexEngagementLeadsRequest;
    static RequestProposalForEngagementLeadRequest;
    static CancelRequestProposalForEngagementLeadRequest;
    static RequestInterviewForEngagementLeadRequest;
    static AssignEngagementLeadRequest;
    static UnassignEngagementLeadRequest;

    async fetchEngagementLeadOptions() {
        let user = TB.auth().registeredClientUser();
        if (!user) {
            return;
        }

        this.constructor.cancelRequest('IndexEngagementLeadsRequest');

        this.constructor.IndexEngagementLeadsRequest = TB.request(
            TB.api_endpoint(
                `/api/clients/${user.clientOrg().id}/projects/${this.id}/engagement-leads`
            )
        );

        let response = await this.constructor.IndexEngagementLeadsRequest.get().catch(console.warn);

        if (!TB.has(response, 'success.data.engagement_leads')) {
            return;
        }

        let engagementLeads = TalentCandidate.makeMany(
            response.success.data.engagement_leads
        );

        // engagementLeads = TB.orderBy(
        //     engagementLeads, candidate => {
        //         if (this.hasEngagementLead() && candidate.user?.id === this.engagement_lead.user.id) {
        //             return 3
        //         }
        //         switch (candidate.candidateStatus()) {
        //             case Project.CandidateStatus.Approved:
        //                 return 2
        //             case Project.CandidateStatus.Rejected:
        //                 return 1
        //             case Project.CandidateStatus.Pending:
        //                 return 0
        //         }
        //     }, 'desc'
        // );

        let leadSchedule = {},
            totalWeeks = this.schedule.length;
        // console.log('fetchEngagementLeadOptions -> totalWeeks', totalWeeks);

        for (let lead of engagementLeads) {
            leadSchedule = {};

            let hoursPerWeek = lead.estimated_hours / totalWeeks;
            // console.log('fetchEngagementLeadOptions -> hoursPerWeek', hoursPerWeek);
            for (let week of this.schedule) {
                leadSchedule[week.started_at] = {
                    started_at: week.started_at,
                    burned_week_hours: hoursPerWeek
                };
            }
            // console.log('fetchEngagementLeadOptions -> leadSchedule', leadSchedule);

            let position = ProjectPosition.make({
                skills: [],
                schedule: TB.values(leadSchedule)
            });
            lead.cacheValuesForPosition(null, position);

            // console.log('fetchEngagementLeadOptions -> engagementLeads[i]', engagementLeads[i]);
        }

        // console.log('fetchEngagementLeadOptions -> engagementLeads', engagementLeads);

        return engagementLeads;
    }

    async toggleEngagementLeadManagement(is_managed) {
        let user = Auth.user();
        if (!user
            || !user.hasRegisteredClientOrg()) {
            return;
        }

        this.ToggleEngagementLeadManagement = TB.request(
            TB.api_endpoint(`/api/clients/${user.clientOrg().id}/projects/${this.id}/update`),
            {is_managed}
        );

        let response = await this.ToggleEngagementLeadManagement.post().catch(console.warn);

        if (!TB.has(response || {}, 'success.data.project')) {

            this.ToggleEngagementLeadManagement.didHandleError = await this.ToggleEngagementLeadManagement.handleError();
            if (this.ToggleEngagementLeadManagement.didHandleError
                && this.ToggleEngagementLeadManagement.shouldRerun) {
                return this.toggleEngagementLeadManagement(
                    is_managed
                );
            }

            return;
        }

        let updatedProject = Project.make({...response.success.data.project})

        await Project.refreshCacheFor(
            updatedProject, 'Cached', true
        );

        return updatedProject;
    }

    static async runEngagementLeadRequest(project, requestProp, requestMethod, appendToUrl = '', runSilently = true) {
        let user = Auth.user();
        if (!user
            || !user.hasRegisteredClientOrg()) {
            return;
        }

        this[requestProp] = TB.request(
            TB.api_endpoint(`/api/clients/${user.clientOrg().id}/projects/${project.id}/engagement-leads${appendToUrl}`)
        );

        let response = await this[requestProp][requestMethod]().catch(console.warn);

        if (!TB.has(response || {}, 'success.data')) {

            this[requestProp].didHandleError = await this[requestProp].handleError();
            if (this[requestProp].didHandleError
                && this[requestProp].shouldRerun) {
                return this.runEngagementLeadRequest(
                    this, requestProp, requestMethod, appendToUrl, runSilently
                );
            }

            return;
        }
        if (!response.success.data.project) {
            return;
        }

        let updatedProject = Project.make({...response.success.data.project})
        await Project.refreshCacheFor(
            updatedProject, 'Cached', runSilently
        );

        return updatedProject;
    }

    async requestInterviewForEngagementLead(userDiscipline) {
        return await this.constructor.runEngagementLeadRequest(
            this,
            'RequestInterviewForEngagementLeadRequest',
            'get',
            `/${userDiscipline.id}/request-interview`,
            true,
        );
    }

    async requestEngagementLeadProposal(userDiscipline) {
        return await this.constructor.runEngagementLeadRequest(
            this,
            'RequestProposalForEngagementLeadRequest',
            'post',
            `/${userDiscipline.id}/request-proposal`,
            true
        );
    }

    async cancelEngagementLeadProposalRequest(userDiscipline) {
        return await this.constructor.runEngagementLeadRequest(
            this,
            'CancelRequestProposalForEngagementLeadRequest',
            'post',
            `/${userDiscipline.id}/cancel-proposal-request`,
            true
        );
    }

    async assignEngagementLead(userDiscipline) {
        return await this.constructor.runEngagementLeadRequest(
            this,
            'AssignEngagementLeadRequest',
            'post',
            `/${userDiscipline.id}/assign`,
            true
        );
    }

    async unassignEngagementLead(userDiscipline) {
        return await this.constructor.runEngagementLeadRequest(
            this,
            'UnassignEngagementLeadRequest',
            'post',
            `/${userDiscipline.id}/unassign`,
            true
        );
    }

    usesEngagementLead() {
        return this.isService()
            && this.is_managed;
    }

    hasEngagementLead() {
        if (!this.usesEngagementLead()) {
            return false;
        }

        return TB.isObject(this.engagement_lead)
            && TB.isObject(this.engagement_lead.user)
            && TB.isDefined(this.engagement_lead.user.id);
    }

    missingNeededEngagementLead() {
        if (!this.usesEngagementLead()) {
            return false;
        }

        return !this.hasEngagementLead();
    }

    /*
    |--------------------------------------------------------------------------
    | Post Requests for Long Term Storage
    |--------------------------------------------------------------------------
    */

    static async create(props) {
        let user = Auth.registeredClientUser();
        if (!user) {
            throw new Error("Unauthorized")
        }

        this.CreateRequest = TB.request(
            TB.api_endpoint(`/api/clients/${user.clientOrg().id}/projects/create`), {...props}
        );

        let response = await this.CreateRequest.post().catch(console.warn);

        if (!response
            || !response.success
            || !response.success.data
            || !response.success.data.project) {
            throw new Error("Something went wrong")
        }

        return this.make(
            response.success.data.project
        );
    }

    async update(props) {
        let user = TB.auth().registeredClientUser();
        if (!user) {
            throw new Error("Unauthorized")
        }

        let model = {...props, schedule: undefined};
        if (TB.isArray(props.positions)) {
            model.positions = this.filterValidPositions(
                props.positions
            );
            model.positions = this.resolveSortOrderForPositions(
                model.positions
            );
            model.positions = TB.map([...model.positions], position => position.transformForUpdate())
        }

        this.constructor.cancelRequest('SyncRequest');

        this.constructor.SyncRequest = TB.request(
            TB.api_endpoint(
                `/api/clients/${user.clientOrg().id}/projects/${this.id}/update`
            ), model
        );

        // console.log('update', model)
        // Check if document upload, then change request to multipart form
        if (TB.isArray(model.positions) && TB.find(model.positions, pos => TB.isObject(pos.description_file))) {
            this.constructor.SyncRequest = this.constructor.SyncRequest.headers({
                'Content-Type': 'multipart/form-data'
            });
        }

        let response = await this.constructor.SyncRequest.post().catch(e => {
            console.warn("UPDATE", e)
        });

        let project = TB.get(response, 'success.data.project', false);

        // console.log('update', project.setup_at)
        if (!project) {
            throw new Error("Something went wrong")
        }

        project = Project.make({...project});

        await this.constructor.refreshCacheFor(
            project
        );

        Team.clearCache();
        TalentCandidate.clearCache();

        // console.log('update', project.setup_at)

        return project;
    }

    static updateHadInputResponseError() {
        return TB.isObject(this.SyncRequest)
            && TB.isObject(this.SyncRequest.response)
            && TB.isObject(this.SyncRequest.response.data)
            && TB.isObject(this.SyncRequest.response.data.error)
            && this.SyncRequest.response.data.error.message === 'invalid_input_format';
    }

    async sync() {
        let project = this,
            props = {...project};

        return this.update(props);
    }

    hasVisibilityPoolRestrictions() {
        return this.visibility_setting_invited ||
            this.visibility_setting_favorites ||
            this.visibility_setting_hired ||
            this.visible_talent_pools?.length > 0
    }

    totalVisibilityPoolRestrictions() {
        let total = this.visible_talent_pools?.length || 0;
        if(this.visibility_setting_invited) {
            total += 1;
        }
        if(this.visibility_setting_favorites) {
            total += 1;
        }
        if(this.visibility_setting_hired) {
            total += 1;
        }
        return total;
    }

    finishSetup() {
        this.setup_at = TB.moment().format(
            'YYYY-MM-DD HH:mm:ss'
        );

        return this.sync();
    }

    requestProposal() {
        this.proposals_requested_at = TB.moment().format(
            'YYYY-MM-DD HH:mm:ss'
        );

        return this.sync();
    }

    cancelProposalRequest() {
        this.proposals_requested_at = null;

        return this.sync();
    }

    latestProposalDocument() {
        if (!this.latest_proposal || !TB.isString(this.latest_proposal.path)) {
            return;
        }

        return this.latest_proposal;
    }

    hasRequestedSOW() {
        return this.isAwaitingContract()
            || this.isPendingContract()
            || this.isActive();
    }

    hasSelectedExperience() {
        return this.wants_intermediate_experience
            || this.wants_senior_experience
            || this.wants_junior_experience
    }

    hasAssignedCandidates() {
        if (this.isBYO() && this.hasFilledAllPositions()) {
            return true;
        }
        if (this.isService() && this.assigned_team_candidate) {
            return true;
        }
        return false;
    }

    canRequestSOW() {
        return this.hasAssignedCandidates() && this.can_request_contract;
    }

    totalUpcomingCandidateMeetings() {
        if(!this.positions.length) return 0
        return TB.sumBy(this.positions, 'upcoming_meetings_count')
    }
    totalProposedCandidateMeetings() {
        if(!this.positions.length) return 0
        return TB.sumBy(this.positions, 'proposed_meetings_count')
    }

    hasActiveCandidateMeetings() {

        // console.log('hasActiveCandidateMeetings', {
        //     upcoming_meetings_count: this.totalUpcomingCandidateMeetings(),
        //     proposed_meetings_count: this.totalProposedCandidateMeetings(),
        //     total: this.totalUpcomingCandidateMeetings() + this.totalProposedCandidateMeetings()
        // })
        return this.has_pending_confirmed_meetings || this.upcoming_meetings_count || (
            (this.totalUpcomingCandidateMeetings() + this.totalProposedCandidateMeetings()) > 0
        )
    }

    async requestSOW() {
        let now = TB.moment().format(
            'YYYY-MM-DD HH:mm:ss'
        );
        let updates = {contract_requested_at: now}
        if(this.hasActiveCandidateMeetings()) {
            let confirmInterviewCancellation = await TB.sysAlert('client.pending_interview_cancellation_on_request_sow');
            if(!confirmInterviewCancellation) {
                return;
            }
            updates.has_confirmed_interview_cancellation = true;
        }

        let update;
        try {
            update = await this.update(updates)
        }catch (e) {
            console.warn('ERROR: requestSOW', e);
        }

        if (!update && TB.has(
            this.constructor.SyncRequest.response,
            'error.data.has_confirmed_interview_cancellation'
        )) {
            let confirmInterviewCancellation = await TB.sysAlert('client.pending_interview_cancellation_on_request_sow');
            if(confirmInterviewCancellation) {
                return this.update({contract_requested_at: now, has_confirmed_interview_cancellation: true})
            }
        }
        return update;
    }

    cancelSOW() {
        return this.update({
            contract_requested_at: false
        });
    }

    async setContractAvailableForClient() {
        const auth = TB.auth().user();
        if (!this.isBYO() || !auth || !auth.canManageClients()) {
            throw new Error("Unauthorized")
        }

        if (!this.isBYO() || !this.hasFilledAllPositions() || !this.isAwaitingContract()) {
            throw new Error("Project SOW Cannot Be Made Available")
        }

        let approveSOWForClientRequest = TB.request(
            TB.api_endpoint(
                `/api/clients/${auth.clientOrg().id}/projects/${this.id}/make-client-contract-available`
            )
        );

        let response = await approveSOWForClientRequest.post().catch(e => console.warn(e));

        if (response && response.status === 403) {
            await TB.alert('confirm', "Request Failed",
                'Cannot Make SOW Available For Client at this time\n\nResponse: ' + response.message
            )
            return true;
        }

        let project = TB.get(response, 'success.data.project', false);

        // console.log('update', project.setup_at)
        if (!project) {
            await TB.showServerErrorToast();
            throw new Error("Something went wrong")
        }

        project = Project.make({...project});

        await this.constructor.refreshCacheFor(
            project
        );

        return project;
    }

    async markProjectAsComplete() {
        const auth = TB.auth().user();

        if (!this.isActive()) {
            throw new Error("Project not active")
        }

        let markProjectAsCompleteRequest = TB.request(
            TB.api_endpoint(
                `/api/clients/${auth.clientOrg().id}/projects/${this.id}/mark-complete`
            ),
        );

        let response = await markProjectAsCompleteRequest.post().catch(e => console.warn(e));

        if (!response) {
            throw new Error("Something went wrong")
        }

        let project = TB.get(response, 'success.data.project', false);

        // console.log('update', project.setup_at)
        if (!project) {

            throw new Error("Something went wrong")
        }

        project = Project.make({...project});

        await this.constructor.refreshCacheFor(
            project
        );

        return project;
    }

    async setClientLeadUpdatesForProject(props) {
        const auth = TB.auth().user();
        if (!auth || !auth.canManageClients()) {
            throw new Error("Unauthorized")
        }

        if (!this.hasAssignedCandidates() || (!props.reset_settings && !(this.isAwaitingContract() || this.isAwaitingKickoff()))) {
            throw new Error("Project SOW Cannot Be Made Available")
        }

        let setClientLeadContractUpdatesRequest = TB.request(
            TB.api_endpoint(
                `/api/clients/${auth.clientOrg().id}/projects/${this.id}/update-contract-terms`
            ),
            props
        ).headers({
            'Content-Type': 'multipart/form-data'
        });

        let response = await setClientLeadContractUpdatesRequest.post().catch(e => console.warn(e));

        if (response && response.status === 403) {
            await TB.alert('confirm', "Request Failed",
                'Cannot Make SOW Available For Client at this time\n\nResponse: ' + response.message
            )
            return true;
        }

        let project = TB.get(response, 'success.data.project', false);

        // console.log('update', project.setup_at)
        if (!project) {

            throw new Error("Something went wrong")
        }

        project = Project.make({...project});

        await this.constructor.refreshCacheFor(
            project
        );

        return project;
    }

    async runBulkActionsForCandidates(actionType, positionId, params) {
        const auth = TB.auth().user();
        if (!auth || !auth.canManageClients() || !TB.find(this.positions, ['id', parseInt(positionId)]) || !params?.talent_ids?.length) {
            throw new Error("Unauthorized")
        }

        let action = '';
        switch (actionType) {
            case 'archive':
                action = 'bulk-dislike';
                break;
            case 'message':
                action = 'bulk-send-email';
                break;
        }
        let runBulkActionsRequest = TB.request(
            TB.api_endpoint(
                `/api/clients/${auth.clientOrg().id}/projects/${this.id}/positions/${parseInt(positionId)}/candidates/${action}`
            ),
            params
        );

        let response = await runBulkActionsRequest.post().catch(e => console.warn(e));

        if (!response?.success) {
            throw new Error("Something went wrong")
        }

        if(!TB.get(response, 'success.data.users', false)) {
            return true;
        }

        let candidates = TalentCandidate.makeMany(TB.get(response, 'success.data.users', false));

        let position = ProjectPosition.make({...(TB.find(this.positions, ['id', parseInt(positionId)]))});

        console.log('runBulkActionsForCandidates', {candidates, position})
        return position.resetCandidatesQueryDataForTalent(candidates)
    }

    async setNotificationUpdatesForProject(props) {
        const auth = TB.auth().user();
        if (!auth || !auth.canManageClients()) {
            throw new Error("Unauthorized")
        }



        let setNotificationUpdatesForProjectRequest = TB.request(
            TB.api_endpoint(
                `/api/clients/${auth.clientOrg().id}/projects/${this.id}/update-notification-settings`
            ), props
        )

        let response = await setNotificationUpdatesForProjectRequest.post().catch(e => console.warn(e));


        let project = TB.get(response, 'success.data.project', false);

        if (!project) {
            await TB.showServerErrorToast();
            return false;
        }

        project = Project.make({...project});

        await this.constructor.refreshCacheFor(
            project
        );

        return project;
    }

     static async submitSatisfactionSurvey(projectId, data) {
        let user = Auth.user();
        if (!user
            || !user.hasRegisteredClientOrg()) {
            return;
        }

        this.submitSatisfactionSurveyRequest = TB.request(
            TB.api_endpoint(`/api/clients/${user.clientOrg().id}/projects/${projectId}/platform-surveys/store`),
            data,
        );

        let response = await this.submitSatisfactionSurveyRequest.post().catch(e => console.warn(e));

        console.log(response,' RESPONSE FROM SERVER')

        if (!TB.has(response || {}, 'success.data')) {
            throw new Error("Something went wrong")
        }
        if (!response.success.data.project) {
            return;
        }

        return 'Survey Updated'
    }

    async setAppSheetLinkingForProject(props) {
        const auth = TB.auth().user();
        if (!auth || !auth.canManageClients()) {
            throw new Error("Unauthorized")
        }



        let setAppSheetLinkingForProjectRequest = TB.request(
            TB.api_endpoint(
                `/api/clients/${auth.clientOrg().id}/projects/${this.id}/update-notification-settings`
            ), props
        )

        let response = await setAppSheetLinkingForProjectRequest.post().catch(e => console.warn(e));


        let project = TB.get(response, 'success.data.project', false);

        if (!project) {
            await TB.showServerErrorToast();
            return false;
        }

        project = Project.make({...project});

        await this.constructor.refreshCacheFor(
            project
        );

        return project;
    }

    async signSowForClient() {
        let now = TB.moment().format(
            'YYYY-MM-DD HH:mm:ss'
        );

        return this.update({
            client_contract_signed_at: now,
        });
    }

    async makeActive() {
        let now = TB.moment().format(
            'YYYY-MM-DD HH:mm:ss'
        );

        return this.update({
            started_at: now,
        });
    }

    async createChangeOrder(props) {

        let response = await ChangeOrder.createChangeOrderForProject(this.id, props, {});

        let project = TB.get(response, 'success.data.project', false);

        // console.log('update', project.setup_at)
        if (!project) {
            throw new Error("Something went wrong")
        }

        project = Project.make({...project});

        await this.constructor.refreshCacheFor(
            project
        );
        let changeOrder = TB.get(response, 'success.data.change_order', false);
        let existing = TB.find(project?.change_orders || [], ['id', changeOrder?.id]);
        if (existing) {
            if (existing && existing.latest_contract && !existing.contract) {
                existing.contract = existing.latest_contract;
            }
            changeOrder = existing
        }

        return ChangeOrder.make(changeOrder);
    }
    async updateChangeOrder(changeOrderId, props) {

        let response = await ChangeOrder.updateChangeOrderForProject(changeOrderId, props, {});

        let project = TB.get(response, 'success.data.project', false);

        // console.log('update', project.setup_at)
        if (!project) {
            throw new Error("Something went wrong")
        }

        project = Project.make({...project});

        await this.constructor.refreshCacheFor(
            project
        );
        let changeOrder = TB.get(response, 'success.data.change_order', false);
        let existing = TB.find(project?.change_orders || [], ['id', changeOrderId]);
        if (existing) {
            if (existing && existing.latest_contract && !existing.contract) {
                existing.contract = existing.latest_contract;
            }
            changeOrder = existing
        }

        return ChangeOrder.make(changeOrder);
    }
    async deleteChangeOrder(changeOrderId) {

        let pendingCO = TB.find(this.change_orders, ['id', changeOrderId]);
        // if (!pendingCO || !!pendingCO.published_at) {
        //     throw new Error("CO cannot be deleted")
        // }
        let response = await ChangeOrder.deleteChangeOrderForProject(changeOrderId, {});

        let project = TB.get(response, 'success.data.project', false);

        // console.log('update', project.setup_at)
        if (!project) {
            throw new Error("Something went wrong")
        }

        project = Project.make({...project});

        await this.constructor.refreshCacheFor(
            project
        );
        return project;
    }

    async publishChangeOrder(changeOrderId) {

        let response = await ChangeOrder.publishChangeOrderForProject(changeOrderId, {});

        let project = TB.get(response, 'success.data.project', false);

        // console.log('update', project.setup_at)
        if (!project) {
            throw new Error("Something went wrong")
        }

        project = Project.make({...project});

        await this.constructor.refreshCacheFor(
            project
        );
        let changeOrder = TB.get(response, 'success.data.change_order', false);
        let existing = TB.find(project?.change_orders || [], ['id', changeOrderId]);
        if (existing) {
            if (existing && existing.latest_contract && !existing.contract) {
                existing.contract = existing.latest_contract;
            }
            changeOrder = existing
        }

        return ChangeOrder.make(changeOrder);
    }

    static UpdateProjectExpensesRequest;

    async updateProjectExpenses(props) {
        let user = TB.auth().registeredClientUser();
        if (!user || this.is_on_hold || !user.canManageClients()) {
            throw new Error("Unauthorized")
        }

        this.constructor.UpdateProjectExpensesRequest = TB.request(
            TB.api_endpoint(
                `/api/clients/${user.clientOrg()?.id}/projects/${this.id}/contract-line-items/update`
            ),
            props
        );

        let response = await this.constructor.UpdateProjectExpensesRequest.post().catch(e => {
            console.warn("UPDATE", e)
        });

        let project = TB.get(response, 'success.data.project', false);

        if (!project) {
            return;
        }

        project = Project.make({...project});

        await this.constructor.refreshCacheFor(
            project
        );
        return project;
    }

    /*
    |--------------------------------------------------------------------------
    | Estimating
    |--------------------------------------------------------------------------
    */

    disciplineHourlyTotals() {
        if (this.isNew() || !this.hasSchedule()) {
            return;
        }

        let totals = {};
        for (let week of this.schedule) {
            for (let discipline of week.disciplines) {
                if (!totals[discipline.id]) {
                    totals[discipline.id] = 0;
                }

                totals[discipline.id] += discipline.burned_week_hours;
            }
        }

        return totals;
    }

    activeDisciplines() {
        return TB.filter(
            this.disciplines, {is_active: true}
        );
    }

    requiredDisciplines() {
        return TB.filter(
            this.activeDisciplines(), {is_required: true}
        );
    }

    hourlyTotal(candidate = this.assigned_team_candidate) {
        if (this.isService()) {
            if (candidate) {
                return parseFloat(candidate.job_candidate?.total_hours)
            }
            return TB.sumBy(this.activeDisciplines(), 'total_hours');
        }

        if (this.isBYO()) {
            return TB.sumBy(this.sortedPositions(), pos => pos.actual_total_periods);
        }

        return 0;
    }

    totalPeriodCost(formatted = true, candidate = this.assigned_team_candidate) {
        let total = 0;
        if (this.isService()) {
            if (candidate) {
                total = candidate.job_candidate?.platform_cost
            }else {
                let scope = this.normalizeScopeForService();
                total = TB.sumBy(scope.phases, 'estimated_cost')

            }
        }

        if (this.isBYO()) {
            total = TB.sumBy(this.sortedPositions(), position => {
                if (position.assignedCandidate()) {
                    return parseFloat(position.assigned_candidate.job_candidate?.exact_platform_cost || position.exact_platform_cost) || 0;
                }
                // if (this.isFixedFee() && !this.hasConfirmedProjectScope() && !position.exact_platform_cost && position.budget) {
                //     return position.exact_platform_cost || position.budget;
                // }
                if (this.isFixedRetainer()) {
                    console.log('pos', position.calculateFixedRetainerBudget())
                    return position.calculateFixedRetainerBudget() || 0
                }
                if (!position.exact_platform_cost && position.budget) {
                    return parseFloat(position.budget) || 0;
                }
                return parseFloat(position.exact_platform_cost) || 0;
            })
        }

        if (!formatted) {
            return total;
        }

        return TB.formatCurrency(total, false);
    }

    averageHourlyRate(formatted = true) {
        let totalHours = this.hourlyTotal(),
            totalCost = this.totalPeriodCost(false);

        if (!totalHours) {
            return formatted ? '---' : null;
        }

        let rate = totalCost / totalHours;
        if (!formatted) {
            return rate;
        }

        return TB.formatCurrency(rate, false);
    }

    serviceFeeForEstimate(total) {
        let feePercent = 0;
        if (this.template
            && this.template.fixed_fee_percent_markup
            && this.isFixedFee()) {
            feePercent = this.template.fixed_fee_percent_markup;
        }

        return feePercent * total;
    }

    serviceFeeFortotalPeriodCost(formatted = true) {
        let total = this.totalPeriodCost(false);

        let fee = this.serviceFeeForEstimate(total);
        if (!formatted) {
            return fee;
        }

        return TB.formatCurrency(fee, false);
    }

    totalCostWithServiceFee(formatted = true) {
        if (this.isFixedFee() && this.actual_cost) {
            if (!formatted) {
                return this.actual_cost;
            }

            return TB.formatCurrency(this.actual_cost, false);
        }

        // let total = this.totalPeriodCost(false),
        // 	serviceFee = this.serviceFeeFortotalPeriodCost(false);

        // let grandTotal = total + serviceFee;
        let grandTotal = this.platform_cost || this.estimated_cost;
        if (!formatted) {
            return grandTotal;
        }

        return TB.formatCurrency(grandTotal, false);
    }

    totalResources() {
        let totalResources = 0;
        if (this.isBYO()) {
            totalResources = this.sortedPositions().length;
        } else if (this.isService()) {
            totalResources = this.requiredDisciplines().length;
        }

        // if (TB.isObject(this.engagement_lead)) {
        //     totalResources += 1;
        // }

        return totalResources;
    }


    /*
    |--------------------------------------------------------------------------
    | Schedule
    |--------------------------------------------------------------------------
    */

    sortedPositionDeliverables() {
        let deliverables = TB.flatMap(this.sortedPositions(), pos => pos.activeDeliverables());

        deliverables = TB.filter(deliverables, del => !!del.target_delivery_at)
        deliverables = TB.orderBy(deliverables, del => TB.moment(del.target_delivery_at).valueOf(), 'asc');
        return deliverables
    }

    timeRangeName() {
        return this.estimated_duration;
    }

    startRangeName() {
        if (!this.start_range) {
            return;
        }

        return laravel.project_start_ranges[this.start_range];
    }

    startRangeDate() {
        if (!this.start_range) {
            return;
        }

        let start_date = laravel.project_start_date_ranges?.[this.start_range];

        if (!start_date) {
            return;
        }

        return new Date(start_date);
    }

    hasTimeline() {
        let startDate = this.anticipatedStart();

        return startDate !== false
    }

    hasTimelineRange() {
        let endDate = this.anticipatedEnd();

        return this.hasTimeline() && endDate !== false
    }

    panelTimeDisplay() {
        if (this.hasTimelineRange()) {
            return this.anticipatedStart().format("ll") + " - " + this.anticipatedEnd().format("ll")
        }
        return TB.isNumber(this.time_range) ? this.timeRangeName() : '---'
    }

    hasSchedule() {
        if(this.isBYO() && this.sortedPositions()?.length) {
            return true;
        }
        if (!this.hasTimeline()) {
            return false;
        }

        return TB.isArray(this.schedule)
            && this.schedule.length > 0;
    }

    anticipatedStart() {
        if (this.isBYO() && this.positions?.length) {

            // if (this.isFixedFee()) {
            //
            //     let deliverables = this.sortedPositionDeliverables();
            //     return TB.moment(TB.first(deliverables).target_delivery_at)
            // }
            let positionsByStartDate = TB.orderBy(this.positions,position => position.startedAt().toDate(),'asc')

            return TB.first(positionsByStartDate).startedAt()
        }
        if (!this.anticipated_started_at) {
            return this.startRangeDate();
        }

        return TB.moment(this.anticipated_started_at);
    }

    anticipatedEnd() {
        if (this.isBYO() && this.positions?.length) {

            // if (this.isFixedFee()) {
            //
            //     let deliverables = this.sortedPositionDeliverables();
            //     return TB.moment(TB.last(deliverables).target_delivery_at)
            // }
            let positionsByEndDate = TB.orderBy(this.positions,position => position.endedAt()?.valueOf(),'desc')

            return TB.first(positionsByEndDate).endedAt()
        }
        if (!this.anticipated_ended_at) {

            if (this.anticipatedStart() && TB.isNumber(this.weeks_to_finish)) {
                let start = TB.moment(this.anticipatedStart()).clone();

                return start.add('weeks', parseInt(this.weeks_to_finish)).clone()
            }

            if (this.anticipatedStart() && this.delivery_date instanceof Date) {
                let endDate = TB.moment(this.delivery_date.toISOString());
                return endDate.clone()
            }

            if (this.positions && this.positions.length) {
                let positions = TB.filter(this.positions, p => p.ended_at);

                let last = TB.maxBy(positions, pos => pos.endedAt().toDate())

                if (last?.endedAt()) {
                    return last.endedAt();
                }
            }

            return false;
        }

        return TB.moment(this.anticipated_ended_at);
    }

    weeksUntilStart() {
        let startDate = this.anticipatedStart();
        if (!startDate) {
            return false;
        }

        return Math.abs(startDate.diff(TB.moment(), 'week'));
    }

    durationInWeeks() {
        if (!this.anticipated_started_at || !this.anticipated_ended_at) {
            return false;
        }

        let start = this.anticipatedStart(),
            end = this.anticipatedEnd();


        return Math.abs(TB.round(end.diff(start, 'weeks', true)));
    }

    durationInMonths() {
        if (!this.anticipated_started_at || !this.anticipated_ended_at) {
            return false;
        }

        let start = this.anticipatedStart(),
            end = this.anticipatedEnd();

        return Math.abs(end.diff(start, 'months'));
    }

    anticipatedDuration() {
        if (!this.anticipated_started_at || !this.anticipated_ended_at) {
            return false;
        }

        let durationInWeeks = this.durationInWeeks();
        if (durationInWeeks <= 24) {
            return `${durationInWeeks} Weeks`;
        }

        let durationInMonths = this.durationInMonths();
        return `${durationInMonths} Months`;
    }

    durationIntervals() {
        // if (this.duration_intervals) {
        // 	return this.duration_intervals;
        // }

        let durationInWeeks = this.durationInWeeks(),
            durationInMonths = this.durationInMonths();

        if ((durationInWeeks % 4) !== 0) {
            durationInMonths++;
        }


        // let durationInterval = 'Week',
        // 	totalIntervals = durationInWeeks;

        let durationInterval = durationInWeeks > 24 ? 'Month' : 'Week',
            totalIntervals = durationInWeeks > 24 ? durationInMonths : durationInWeeks;

        let start = this.anticipatedStart();
        let end = this.anticipatedEnd();
        let intervals = TB.range(totalIntervals);
        let current = start.clone()
        return TB.map(intervals, (interval, i) => {
            let date = start.clone().add(interval, durationInterval)
            if (i === (intervals.length - 1) && date.isBefore(end)) {
                date = end.clone();
            }
            const step = interval + 1;
            return {
                interval: durationInterval,
                date,
                step,
                name: `${durationInterval} ${step}`,
                count: durationInWeeks > 24 ? 4 : current.diff(current, 'weeks', true),
            }

        });

        // this.duration_intervals = intervals;

        // return this.duration_intervals;
    }

    positionDurations() {
        // console.log('Project @ positionDurations');

        let positions = this.sortedPositions();
        if (!positions?.length) {
            return;
        }

        let orderedPositions = TB.orderBy(positions, pos => pos.startedAt()?.valueOf(), 'asc');

        let startPosition = TB.first(orderedPositions)
        let endPosition = TB.last(orderedPositions);

        startPosition = TB.moment(startPosition.startedAt())
        endPosition = TB.moment(endPosition.endedAt())

        // if (this.isFixedFee()) {
        //     let deliverables = this.sortedPositionDeliverables();
        //     startDate = TB.moment(TB.first(deliverables).target_delivery_at);
        //     endDate = TB.moment(TB.last(deliverables).target_delivery_at)
        // }

        let positionLookup = {}
        TB.map(this.positions, position => {
            positionLookup[position.id] = [];
            let startWeek = 1;
            let currentWeek = startPosition.clone();

            let positionStart = position.startedAt()
            let positionEnd = position.endedAt()

            let isActive = positionStart.isSame(currentWeek, 'week');
            if(isActive) {
                positionLookup[position.id].push({
                    isActive: true,
                    start: startWeek,
                    count: TB.round(positionEnd.diff(currentWeek, 'week', true))
                })
            }else {
                startWeek = TB.round(positionStart.diff(startPosition, 'week', true));
                positionLookup[position.id].push({
                    isActive: false,
                    count: TB.round(positionStart.diff(startPosition, 'week', true))
                })
                positionLookup[position.id].push({
                    isActive: true,
                    start: startWeek + 1,
                    count: TB.round(positionEnd.diff(positionStart, 'week', true))
                })
            }

            if(positionEnd.isBefore(endPosition, 'week')) {
                positionLookup[position.id].push({
                    isActive: false,
                    count: TB.round(endPosition.diff(positionEnd, 'week', true))
                })
            }

            if (this.isFixedFee() && position.activeDeliverables()?.length) {
                let currentWeek = startPosition.clone();
                positionLookup[position.id] = TB.map(positionLookup[position.id], bar => {
                    if (bar.isActive) {
                        bar.items = [];
                        TB.map(position.activeDeliverables(), del => {
                            let diff = TB.round(TB.moment(del.target_delivery_at).diff(currentWeek, 'week', true));
                            let existing = TB.findIndex(bar.items, ['start', diff]);
                            if(existing >= 0) {
                                bar.items[existing].deliverables.push(del);
                            }else {
                                bar.items.push({
                                    isActive: true,
                                    start: diff,
                                    deliverables: [del]
                                })
                            }
                        })
                        // for (let i = 0; i < TB.round(positionEnd.diff(currentWeek, 'week', true)); i++) {
                        //     let week = currentWeek.clone().add(i, 'week').clone();
                        //     let activedels = TB.filter(position.activeDeliverables(), del => week.isSame(TB.moment(del.target_delivery_at).startOf('week'), 'week'));
                        //
                        //     bar.items.push({
                        //         isActive: activedels.length > 0,
                        //         start: i,
                        //         deliverables: activedels
                        //     })
                        // }
                    }else {
                        currentWeek = startPosition.clone().add(bar.count, 'week')
                    }
                    return bar;
                })

            }
        })
        return positionLookup;
    }

    disciplineDurations() {
        // console.log('Project @ disciplineDurations');
            let durations = TB.reduce(this.disciplines, (result, discipline) => {
                    result[discipline.id] = [];
                return result;
            }, {});

        TB.map(this.phases, phase => {
            TB.map(TB.filter(phase.deliverables, ['is_active', true]), deliverable => {

                TB.map(TB.keys(durations), disciplineId => {
                    const activeDiscipline = TB.find(TB.flatMap(deliverable.activities, 'disciplines'), ['id', parseInt(disciplineId)])
                    durations[disciplineId].push({
                        isActive: activeDiscipline,
                        count: deliverable.total_hours
                    })
                })
                // TB.map(deliverable.activities, activity => {
                //     TB.map(activity.disciplines, actDiscipline => {
                //         // console.log('actDiscipline', actDiscipline)
                //         TB.map(TB.keys(durations), disciplineId => {
                //             durations[disciplineId].push({
                //                 isActive: actDiscipline.id === parseInt(disciplineId),
                //                 count: actDiscipline.total_hours
                //             })
                //         })
                //     })
                // })
            })
        })

        return durations;
    }

    deliverableDurations() {
        // console.log('Project @ disciplineDurations');
        let scope = this.normalizeScopeForService()
        let durations = TB.reduce(TB.flatMap(scope.phases, 'deliverables'), (result, deliverable) => {
            result[deliverable.id] = [];
            return result;
        }, {});

        TB.map(scope.phases, (phase, index) => {
            TB.map(TB.filter(phase.deliverables, ['is_active', true]), deliverable => {
                TB.map(TB.keys(durations), deliverableId => {
                    const activeDeliverable = deliverable.id === parseInt(deliverableId)
                    durations[deliverableId].push({
                        isActive: activeDeliverable,
                        count: deliverable.total_hours,
                        disciplines: activeDeliverable ? TB.uniqBy(TB.flatMap(deliverable.activities, 'disciplines'), 'id') : []
                    })
                })
            })
            // TB.map(TB.filter(phase.deliverables, ['is_active', true]), deliverable => {
            //
            //     TB.map(TB.keys(durations), disciplineId => {
            //         const activeDiscipline = TB.find(TB.flatMap(deliverable.activities, 'disciplines'), ['id', parseInt(disciplineId)])
            //         durations[disciplineId].push({
            //             isActive: activeDiscipline,
            //             count: deliverable.total_hours
            //         })
            //     })
            //     // TB.map(deliverable.activities, activity => {
            //     //     TB.map(activity.disciplines, actDiscipline => {
            //     //         // console.log('actDiscipline', actDiscipline)
            //     //         TB.map(TB.keys(durations), disciplineId => {
            //     //             durations[disciplineId].push({
            //     //                 isActive: actDiscipline.id === parseInt(disciplineId),
            //     //                 count: actDiscipline.total_hours
            //     //             })
            //     //         })
            //     //     })
            //     // })
            // })
        })

        return durations;
    }

    disciplineAvailabilityNeeds(addWeeks = 0) {
        if (this.isNew() || !this.schedule) {
            return;
        }

        let disciplineLookup = this.disciplineLookup();

        let availabilityNeeds = {};
        for (let week of this.schedule) {
            for (let discipline of week.disciplines) {
                if (!disciplineLookup[discipline.id]
                    || !disciplineLookup[discipline.id].is_required
                    || !disciplineLookup[discipline.id].is_active) {
                    continue;
                }

                let startedAt = TB.moment(
                    week.started_at
                ).add(
                    addWeeks, 'weeks'
                ).format().replace(
                    'Z', '+00:00'
                );

                if (!availabilityNeeds[discipline.id]) {
                    availabilityNeeds[discipline.id] = {};
                }
                if (!availabilityNeeds[discipline.id][startedAt]) {
                    availabilityNeeds[discipline.id][startedAt] = 0;
                }

                availabilityNeeds[discipline.id][startedAt] += discipline.burned_week_hours;
            }
        }

        return availabilityNeeds;
    }

    /*
    |--------------------------------------------------------------------------
    | SOW
    |--------------------------------------------------------------------------
    */

    acceptsStandardSOW() {
        return !this.isService() && this.accepts_standard_time_materials_contract
    }
    hasContract() {
        let doc = this.latestContract();

        return TB.isObject(doc);
    }

    latestContract() {
        if (!this.latest_contract || !TB.isString(this.latest_contract.path)) {
            return;
        }

        return Document.make(this.latest_contract);
    }

    hasApprovedLatestContract() {
        if (!this.latestContract()) {
            return false;
        }

        return this.has_approved_contract_details;
    }

    hasSignedLatestContract() {

        if (this.isAwaitingKickoff()) {
            return true;
        }
        return this.client_contract_management_setting === ContractManagementSettings.ApprovedOffline ||
            this.client_contract_management_setting === ContractManagementSettings.NoSow ||
            (this.client_contract_management_setting === ContractManagementSettings.ApprovedOnline && !!this.client_contract_signed_at)
    }

    sowDocumentsAndRevisions() {

        let documents = TB.orderBy(Document.makeMany(this.documents || []), 'uploaded_at', 'asc');

        return TB.filter(documents, doc =>  doc.isTypeGeneratedContract() || doc.isTypeContract() || doc.isTypeClientRevisedProposal())
    }

    hasAutoGeneratedContract() {

        let documents = this.sowDocumentsAndRevisions();

        return documents.length === 1 && TB.first(documents).isTypeGeneratedContract();
    }
    hasUploadedManualContract() {

        let documents = this.sowDocumentsAndRevisions();

        return documents.length === 1 && TB.first(documents).isTypeContract();
    }

    sowSteps() {

        if (this.isBYO()) {
            if (!this.acceptsStandardSOW()) {
                return [
                    BiddingContractApprovalDocumentsSubstep
                ]
            }else {

                if (this.hasUploadedManualContract()) {
                    return [BiddingContractApprovalDocumentsSubstep]
                }

                let steps = [
                    BiddingContractContactDetailsSubstep,
                ]
                if (this.hasSchedule()) {
                    steps.push(ProjectBiddingContractScheduleSubstep);
                }
                if (this.hasEstimate()) {
                    steps.push(ProjectBiddingContractFeesSubstep);
                }
                steps.push(
                    BiddingContractSummarySubstep,
                    BiddingContractApprovalDocumentsSubstep
                )
                return steps;
            }

        }else {
            if (!this.acceptsStandardSOW()) {
                return [
                    // BiddingContractTeamMembersSubstep,
                    BiddingContractApprovalDocumentsSubstep
                ]
            }else {
                if (this.hasUploadedManualContract()) {
                    return [BiddingContractApprovalDocumentsSubstep]
                }
                let steps = [
                    BiddingContractContactDetailsSubstep,
                    BiddingContractTeamMembersSubstep
                ]
                if (this.hasFeaturedDeliverables()) {
                    steps.push(ProjectBiddingContractDeliverablesSubstep);
                }
                if (this.hasEstimate()) {
                    steps.push(ProjectBiddingContractFeesSubstep);
                }
                steps.push(
                    BiddingContractSummarySubstep,
                    BiddingContractApprovalDocumentsSubstep
                )
                return steps;
            }
        }
    }

    sowStepFromSlug(slug) {
        let steps = this.sowSteps();

        let lookup = TB.keyBy(steps, 'SubstepSlug');

        return lookup[slug];
    }

    sowStepNames() {
        let steps = this.sowSteps();

        return TB.pluck(steps, 'SubstepName');
    }

    sowStepSlugs() {
        let steps = this.sowSteps();

        return TB.pluck(steps, 'SubstepSlug');
    }

    sowStepNameFromSlug(slug) {
        let stepName = TB.titleCase(slug);

        if (stepName.includes('High Level')) {
            stepName.replace('High Level', 'High-level')
        }

        return stepName;
    }

    briefSections(candidate) {
        let sections = [
            {
                label: (this.isFixedFee() && !this.hasAssignedCandidates()) ? 'Total Budget' :'Estimated Fee', value: () => {
                    if (!this.hasConfirmedProjectScope() && this.template) {
                        return 'Pending Scope Call';
                    }

                    let assignedCost = this.totalPeriodCost(false, candidate);
                    if (assignedCost) {
                        return TB.formatCurrency(assignedCost, false);
                    }

                    let estCost = this.platform_cost;

                    if (!this.hasEstimate()
                        && !TB.isNaN(parseInt(this.platform_cost))
                        && parseInt(this.platform_cost) > 0) {
                        estCost = this.platform_cost;
                    }

                    return TB.formatCurrency(parseInt(estCost), false)
                },
                format: value => TB.formatCurrency(value, false)
            },
        ];
        if (!this.isFixedRetainer() && this.hourlyTotal(candidate) > 0) {
            sections.push({
                label: 'Total Hours',
                value: () => {
                    if (!this.hasConfirmedProjectScope()) {
                        return 'TBD';
                    }

                    return TB.ceil(this.hourlyTotal(candidate))
                }
            })
        }
        if (this.isService() && (candidate || this.hasAssignedCandidates())) {
            sections.push({
                label: 'Team',
                value: () => {
                    return candidate?.name || this.assigned_team_candidate?.name || '';
                }
            })
        }

        sections = [
            ...sections,
            {
                label: '# of Resources',
                value: () => {
                    if(this.isBYO()) {
                        return this.positions?.length || 0
                    }else if (this.isService()) {
                        if (candidate || this.assigned_team_candidate?.name) {
                            return TB.filter((candidate || this.assigned_team_candidate)?.job_candidate.talent_opps, opp => !opp.isLost?.())?.length
                        }
                        return TB.filter(this.disciplines || [], ['is_active', true])?.length
                    }

                    return 0;
                }
            },
            {label: 'Project Start Date', value: () => this.anticipatedStart()?.format('ll')},
            {label: 'Project End Date', value: () => this.anticipatedEnd()?.format('ll')}
        ]
        return sections;
    }

    sowBriefSections(candidate) {
        let sections = this.briefSections(candidate);

        if (this.acceptsStandardSOW() && this.isBYO()) {
            if (this.expense_budget) {
                sections.push({
                        label: 'Expense Budget',
                        value: () => this.expense_budget ? TB.formatCurrency(this.expense_budget, false) : '$0'
                    }
                )
            }
            if (this.client_contact_name) {
                sections.push({
                    label: 'Client Contact Name', value: () => this.client_contact_name || 'N/A'
                })
            }
            if (this.client_contact_email) {
                sections.push({
                    label: 'Client Contact Email', value: () => this.client_contact_email || 'N/A'
                })
            }
        }
        return sections;
    }

    static ApproveSOWContractDetailsRequest;

    async approveSOWContractDetails() {
        let user = TB.auth().registeredClientUser();
        if (!user || !this.acceptsStandardSOW() || !this.isBYO()) {
            return;
        }

        this.constructor.ApproveSOWContractDetailsRequest = TB.request(
            TB.api_endpoint(
                `/api/clients/${user.clientOrg().id}/projects/${this.id}/contract-details/approve`
            )
        );

        let response = await this.constructor.ApproveSOWContractDetailsRequest.post().catch(e => {
            console.warn("UPDATE", e);
            TB.showServerErrorToast();
        });

        let project = TB.get(response, 'success.data.project', false);

        if (!project) {
            return;
        }

        project = Project.make({...project});

        await this.constructor.refreshCacheFor(
            project
        );
        return project;
    }

    static CancelSOWApprovalRequest;

    async cancelSOWApproval() {
        let user = TB.auth().registeredClientUser();
        if (!user || !this.acceptsStandardSOW() || !this.isBYO()) {
            return;
        }

        this.constructor.CancelSOWApprovalRequest = TB.request(
            TB.api_endpoint(
                `/api/clients/${user.clientOrg().id}/projects/${this.id}/contracts/cancel-approval`
            )
        );

        let response = await this.constructor.CancelSOWApprovalRequest.post().catch(e => {
            console.warn("UPDATE", e)
        });

        let project = TB.get(response, 'success.data.project', false);

        if (!project) {
            return;
        }

        project = Project.make({...project});

        await this.constructor.refreshCacheFor(
            project
        );
        return project;
    }

    static UploadAmendedSOWProposalRequest;

    async uploadAmendedSOWProposal(props) {
        let user = TB.auth().registeredClientUser();
        if (!user || !this.acceptsStandardSOW() || !this.isBYO() || !this.hasApprovedLatestContract()) {
            return;
        }

        this.constructor.UploadAmendedSOWProposalRequest = TB.request(
            TB.api_endpoint(
                `/api/clients/${user.clientOrg().id}/projects/${this.id}/contracts/upload-amended`
            ), props
        ).headers({
            'Content-Type': 'multipart/form-data'
        });

        let response = await this.constructor.UploadAmendedSOWProposalRequest.post().catch(e => {
            console.warn("UPDATE", e)
        });

        let project = TB.get(response, 'success.data.project', false);

        if (!project) {
            return;
        }

        project = Project.make({...project});

        await this.constructor.refreshCacheFor(
            project
        );

        return project;
    }

    hasSelectedTeam() {
        return TB.isObject(this.team);
    }

    selectedTeam() {
        if (!this.team) {
            return;
        }

        return Team.make({...this.team});
    }

    featuredDeliverables() {
        if (!this.deliverables) {
            return [];
        }

        return TB.filter(
            this.deliverables, {is_featured: true}
        );
    }

    hasFeaturedDeliverables() {
        return this.featuredDeliverables().length > 0;
    }

    groupedDeliverablesByCategory() {
        if (!this.deliverables) {
            return {};
        }

        let featuredDeliverables = this.featuredDeliverables();

        let lookup = TB.groupBy(featuredDeliverables, 'category.name');

        let grouped = TB.map(lookup, (group, name) => {
            return {
                name: name,
                deliverables: group,
            };
        });

        return TB.values(grouped);
    }

    groupedAllDeliverablesByCategory() {
        if (!this.deliverables) {
            return {};
        }

        let featuredDeliverables = this.deliverables;

        let lookup = TB.groupBy(featuredDeliverables, 'category.name');

        let grouped = TB.map(lookup, (group, name) => {
            return {
                name: name,
                deliverables: group,
            };
        });

        return TB.values(grouped);
    }

    /*
    |--------------------------------------------------------------------------
    | Status
    |--------------------------------------------------------------------------
    */

    static Status = ProjectStatus;

    isNew() {
        return this.status == ProjectStatus.New;
    }

    isCancelled() {
        return this.is_cancelled || this.status == ProjectStatus.Cancelled;
    }

    isBidding() {
        return this.isSelectingTalent()
            || this.isAcceptingProposals()
            || this.isAwaitingContract()
            || this.isPendingContract()
    }

    isPendingScope() {
        return this.status === ProjectStatus.PendingScope;
    }

    isSelectingTalent() {
        return this.isPendingScope() || this.status === ProjectStatus.SelectingTalent;
    }

    isAcceptingProposals() {
        return this.status === ProjectStatus.AcceptingProposals;
    }

    isAwaitingContract() {
        return this.status === ProjectStatus.AwaitingContract;
    }

    isPendingSignedContract() {
        return this.status === ProjectStatus.PendingContract;
    }

    isAwaitingKickoff() {
        return this.status === ProjectStatus.PendingKickoff;
    }

    isPendingContract() {
        return this.isPendingSignedContract() || this.isAwaitingKickoff();
    }

    canRequestProposal() {
        if (this.isService()) {
            return this.isAcceptingProposals();
        }

        return this.hasFilledAllPositions();
    }

    hasRequestedProposal() {
        if (this.isAwaitingContract() || this.isPendingContract()) {
            return true;
        }
        if (this.isService()) {
            return this.shortlisted_candidates_count > 0;
        }
        return TB.isString(this.proposals_requested_at);
    }

    lastRequestedProposalAt(format = true) {
        if (!this.proposals_requested_at) {
            return;
        }

        let requestedAt = TB.moment(this.proposals_requested_at);
        if (!format) {
            return requestedAt;
        }

        return requestedAt.format('MMM D YYYY');
    }

    hasReceivedProposal() {
        let doc = this.latestProposalDocument();

        return TB.isObject(doc);
    }

    lastReceivedProposalAt(format = true) {
        let proposalDoc = this.latestProposalDocument();
        if (!proposalDoc) {
            return;
        }

        let uploadedAt = TB.moment(proposalDoc.created_at);
        if (!format) {
            return uploadedAt;
        }

        return uploadedAt.format('MMM D YYYY');
    }

    isActive() {
        return this.status === ProjectStatus.Active || this.status === ProjectStatus.Complete;
    }
    isComplete() {
        return this.status === ProjectStatus.Complete;
    }

    static statusOptions() {
        let options = TB.values({...ProjectStatus});
        let displayOptions = {};
        for (let option of options) {
            displayOptions[this.displayStatusFor(option)] = true;
        }

        return TB.keys(displayOptions);
    }

    static displayStatusFor(projectStatus) {
        let transKey = '';
        switch (projectStatus) {
            case ProjectStatus.New:
                transKey = 'new';
                break;
            case ProjectStatus.SelectingTalent:
                transKey = 'find_talent';
                break;
            case ProjectStatus.AcceptingProposals:
                transKey = 'proposed';
                break;
            case ProjectStatus.AwaitingContract:
            case ProjectStatus.PendingContract:
            case ProjectStatus.PendingKickoff:
                transKey = 'sow';
                break;
            case ProjectStatus.Active:
                transKey = 'active';
                return 'Active'
            case ProjectStatus.Complete:
                transKey = 'complete';
                return 'Complete'
            default:
                return projectStatus;
        }

        if (!transKey) {
            return projectStatus;
        }

        let fullKey = `projects.client_dashboard.status_${transKey}`;

        return TB.trans(fullKey);
    }

    static statusFlatLookup() {
        let lookup = laravel.project_statuses;
        let statuses = []
        for (let [value, label] of Object.entries(lookup)) {
            statuses.push({label, value})
        }
        return statuses;
    }

    displayStatus() {
        let status = this.status;
        if (this.isBYO() && status === ProjectStatus.SelectingTalent && this.hasAnyCandidatesForAnyPositions()) {
            status = ProjectStatus.AcceptingProposals;
        }
        return this.constructor.displayStatusFor(
            status
        );
    }

    displayType() {
        if (this.isBYO()) return 'Hire by Open Positions';
        else if (this.isService()) return 'Find Teams by Project Type';
    }

    statusColor() {
        switch (this.status) {
            case ProjectStatus.SelectingTalent:
            case ProjectStatus.AcceptingProposals:
            case ProjectStatus.AwaitingContract:
            case ProjectStatus.PendingContract:
            case ProjectStatus.PendingKickoff:
                if (this.is_on_hold) {
                    return TB.config('color.disabled')
                }
                break;
        }

        return Project.colorForStatus(this.status);
    }

    statusClass() {
        return Project.classForStatus(this.status);
    }

    static colorForStatus(status) {
        switch (status) {
            case ProjectStatus.New:
                return TB.config('color.blue');
            case ProjectStatus.SelectingTalent:
            case ProjectStatus.PendingScope:
            case ProjectStatus.AcceptingProposals:
            case ProjectStatus.AwaitingContract:
            case ProjectStatus.PendingContract:
            case ProjectStatus.PendingKickoff:
                return TB.config('color.purple');
            case ProjectStatus.Active:
                return TB.config('color.black');
            case ProjectStatus.Complete:
                return TB.config('color.green');
            case ProjectStatus.Cancelled:
                return TB.config('color.red');
        }
    }

    static classForStatus(status) {
        switch (status) {
            case ProjectStatus.New:
                return "info";
            case ProjectStatus.SelectingTalent:
            case ProjectStatus.AcceptingProposals:
            case ProjectStatus.PendingScope:
            case ProjectStatus.AwaitingContract:
            case ProjectStatus.PendingContract:
            case ProjectStatus.PendingKickoff:
                return "primary";
            case ProjectStatus.Active:
                return "dark";
            case ProjectStatus.Complete:
                return "success";
            case ProjectStatus.Cancelled:
                return "danger";
        }
    }

    canCancel() {
        return this.can_be_cancelled
    }


    canPutOnHold() {
        let onHoldAvailable = [ProjectStatus.PendingScope, ProjectStatus.SelectingTalent, ProjectStatus.AcceptingProposals]
        return onHoldAvailable.includes(this.status)
    }

    confirmCancelProject = async() => {
        return await TB.alert('error', 'Cancel Project?',
            'Are you sure you want to cancel this project. All information will be deleted and this cannot be undone.', [
                {title: 'Yes, Continue'},
                {title: 'Cancel'}
            ]
        )
    }

    async addToCancel(skipConfirm = false) {
        let user = Auth.registeredClientUser();
        if (!user || !this.canCancel()) {
            return;
        }

        if (!skipConfirm) {
            let confirm = await this.confirmCancelProject()

            if (!confirm) return false;
        }
        this.constructor.CancelRequest = TB.request(
            TB.api_endpoint(`/api/clients/${user.clientOrg().id}/projects/${this.id}/cancel`)
        );

        let response = await this.constructor.CancelRequest.post().catch(console.warn);

        if (!TB.has(response, 'success')) {
            return;
        }

        if (this.constructor.Cached) {
            await this.constructor.refreshCacheFor(
                Project.make({...this, is_cancelled: true, status: 'Cancelled'})
            );
        }

        return true;
    }

    async cancelByClientLead(params = {}) {
        let user = Auth.registeredClientUser();
        if (!user || !user.canManageClients() || !this.canCancel()) {
            return;
        }

        const CancelLeadRequest = TB.request(
            TB.api_endpoint(`/api/clients/${user.clientOrg().id}/projects/${this.id}/cancel`), params
        );

        let response = await CancelLeadRequest.post().catch(console.warn);

        if (!TB.has(response, 'success')) {
            return;
        }

        if (this.constructor.Cached) {
            await this.constructor.refreshCacheFor(
                Project.make({...this, is_cancelled: true, status: 'Cancelled'})
            );
        }

        return true;
    }

    async confirmToggleOnHold(props = {}, skipRequest = false) {
        let user = Auth.registeredClientUser();
        if (!user) {
            return;
        }

        let updates = {...props, is_on_hold: !this.is_on_hold};
        let confirm = false;

        if(updates.is_on_hold) {
            confirm = await TB.alert(
                'warning',
                'Put Project on Hold?',
                'You can place this project on hold until a later date. No information will be lost and interested talent will be notified. \n\n Note: the project will not be editable until it is resumed as an active job search.',
                [{ title: 'Yes, Continue' }, { title: 'Cancel' }]
            )
            if (this.hasActiveCandidateMeetings()) {
                updates.has_confirmed_interview_cancellation = true;
            }
            // if (this.hasActiveCandidateMeetings()) {
            //     confirm = await TB.sysAlert('client.pending_interview_cancellation_on_project_hold');
            //     updates.has_confirmed_interview_cancellation = true;
            // } else {
            //     confirm = await TB.sysAlert('client.project_put_on_hold_btn_click');
            // }
        } else {
            // confirm = await TB.sysAlert('client.project_make_active_btn_click')
            confirm = await TB.alert(
                'warning',
                'Resume this Project?',
                'Resuming the project from hold will make the project visible to talent. Previously interested talent will be notified that the project has resumed as an active job search.',
                [{ title: 'Yes, Continue' }, { title: 'Cancel' }]
            )
        }

        if (!confirm) return false;
        if (skipRequest) return updates;

        this.requestToggleOnHold(updates);
    }

    async requestToggleOnHold(updates) {
        let success = await this.update(updates);

        if (success) {
            updates.is_on_hold ? TB.sysAlert('client.project_placed_on_hold') : TB.sysAlert('client.project_removed_from_on_hold')
            return success
        } else if (updates.is_on_hold && TB.has(this.constructor.SyncRequest.response, 'error.data.has_confirmed_interview_cancellation')) {
            let confirm = await TB.sysAlert('client.pending_interview_cancellation_on_project_hold');

            if (confirm) {
                return this.confirmToggleOnHold({has_confirmed_interview_cancellation: true})
            }
        }
        return false;
    }


    async toggleOnHold(props = {}) {
        let user = Auth.registeredClientUser();
        if (!user) {
            return;
        }

        let updates = {...props, is_on_hold: !this.is_on_hold};

        let confirm = false;

        if(updates.is_on_hold) {
            if(this.hasActiveCandidateMeetings()) {
                confirm = await TB.sysAlert('client.pending_interview_cancellation_on_project_hold');
                updates.has_confirmed_interview_cancellation = true;
            }else {
                confirm = await TB.sysAlert('client.project_put_on_hold_btn_click');
            }

        }else {
            confirm = await TB.sysAlert('client.project_make_active_btn_click')
        }

        if (!confirm) return false;

        let success = await this.update(updates);

        if (success) {
            return updates.is_on_hold
                ?  TB.sysAlert('client.project_placed_on_hold')
                :  TB.sysAlert('client.project_removed_from_on_hold')
        }else if (
            updates.is_on_hold && TB.has(this.constructor.SyncRequest.response, 'error.data.has_confirmed_interview_cancellation')
        ) {

            let confirm = await TB.sysAlert('client.pending_interview_cancellation_on_project_hold');

            if(confirm) {
                return this.toggleOnHold({has_confirmed_interview_cancellation: true})
            }
        }
        return false;
    }

    /*
    |--------------------------------------------------------------------------
    | Visibility
    |--------------------------------------------------------------------------
    */
    canViewSOWApproval() {
        if (!TB.auth().user()?.canViewSOWForProject(this)) {
            return false;
        }
        if (this.isBYO() &&
            this.acceptsStandardSOW() &&
            (this.isAwaitingContract() || this.isPendingContract())
        ) {
            return true;
        }

        return this.hasContract() && this.isPendingContract()
    }

    canViewTalentSelection() {

    }

    /*
    |--------------------------------------------------------------------------
    | Candidate Status
    |--------------------------------------------------------------------------
    */

    static CandidateStatus = ProjectCandidateStatus;

    transTypeKey() {
        switch (true) {
            case this.isService():
                return 'service';
            case this.isBYO():
                return 'byo';
        }
    }

    panelViewButtonTitle() {
        let transStatusKey;
        switch (true) {
            case this.isNew():
                transStatusKey = 'new';
                break;
            case this.isSelectingTalent():
                transStatusKey = 'select_talent';
                break;
            case this.isAcceptingProposals():
                transStatusKey = 'select_proposal';
                break;
            case this.isAwaitingContract():
                transStatusKey = 'awaiting_sow';
                break;
            case this.isPendingContract():
                transStatusKey = 'confirm_sow';
                break;
            default:
                transStatusKey = 'active';
                break;
        }

        let transTypeKey = this.transTypeKey();
        if (!transTypeKey) {
            return 'View Project';
        }

        return TB.trans(
            `projects.client_dashboard.${transStatusKey}_${transTypeKey}_panel_view_btn`
        );
    }

    shopSteps() {
        let shopSteps = [];
        if (this.isService()) {
            shopSteps = [
                {
                    name: 'Select Team',
                    display_status: 'find_talent',
                    isComplete: this.isAcceptingProposals() || this.isAwaitingContract() || this.isPendingContract(),
                    isActive: this.isSelectingTalent(),
                },
                {
                    name: 'Choose Proposal',
                    display_status: 'proposed',
                    isComplete: this.isAwaitingContract() || this.isPendingContract(),
                    isActive: this.isAcceptingProposals(),
                },
                {
                    name: 'Review SOW',
                    display_status: 'sow',
                    isComplete: this.isActive(),
                    isActive: this.isAwaitingContract() || this.isPendingContract(),
                },
            ];
        }


        if (this.isBYO()) {

            let inProposalProcess = this.hasRequestedProposal();
            let sowReady = this.isPendingContract() || this.isAwaitingContract();
            let hasCandidates = this.hasAnyCandidatesForAnyPositions();
            let filledAllPositions = this.hasFilledAllPositions();
            let isActive = this.isActive();
            // console.log({inProposalProcess, sowReady, hasCandidates, filledAllPositions, isActive})

            shopSteps = [
                {
                    name: 'Select Talent',
                    display_status: 'find_talent',
                    isComplete: hasCandidates || inProposalProcess,
                    isActive: !hasCandidates && !inProposalProcess,
                },
                {
                    name: 'Choose Candidates',
                    display_status: 'proposed',
                    isComplete: filledAllPositions || sowReady,
                    isActive: hasCandidates && !sowReady,
                },
                {
                    name: 'Review SOW',
                    display_status: 'sow',
                    isComplete: isActive,
                    isActive: sowReady
                },
            ];
        }


        return shopSteps.map((step, index) => {

            return {
                ...step,
                render: () => {
                    if (step.isActive) {
                        return (
                            <Link
                                to={this.detailLink()}
                                className={TB.mapClass(
                                    'project-panel-steps-btn btn btn-block', {
                                        [`btn-${this.statusClass()}`]: !this.is_on_hold,
                                        'no-click btn-disabled text-white': this.is_on_hold
                                    })
                                }
                                disabled={this.is_on_hold}
                                key={`project-${this.id}-shop-steps-${index}`}>
                                Step {index + 1}. {step.name}
                            </Link>
                        );
                    }

                    return (
                        <p className={"project-panel-steps-text " + (
                            step.isComplete && 'complete '
                        )}
                           key={`project-${this.id}-shop-steps-${index}`}>
                            Step {index + 1}.
                            <b>{step.name}</b>
                            <i className={step.isComplete ?
                                "fas fa-check text-success" :
                                "fas fa-chevron-right"}/>
                        </p>
                    );
                }
            }
        });
    }

    panelTotalProposalsText() {
        return TB.trans(
            `projects.client_dashboard.panel_total_proposals_text`, {
                proposal_count: this.total_proposals_received || 'No'
            }
        );
    }

    panelLastProposalsText() {
        let transKey, transProps = {};
        if (this.hasReceivedProposal()) {
            transKey = 'panel_last_proposal_received_text';
            transProps = {
                last_proposal_received_at: this.lastReceivedProposalAt(),
            };
        } else if (this.hasRequestedProposal()) {
            transKey = 'panel_last_proposal_requested_text';
            transProps = {
                last_proposal_requested_at: this.lastRequestedProposalAt(),
            };
        } else {
            transKey = 'panel_no_proposals_requested_text';
        }

        return TB.trans(
            `projects.client_dashboard.${transKey}`,
            transProps
        );
    }

    panelNewTeamsSectionText() {
        let transTypeKey = this.transTypeKey();
        if (!transTypeKey) {
            return false;
        }

        let prefix = 'projects.client_dashboard.panel_new_';

        return {
            title: TB.trans(`${prefix}${transTypeKey}_talent_section_title`),
            body: TB.trans(`${prefix}${transTypeKey}_talent_section_body`),
        };
    }

    /*
    |--------------------------------------------------------------------------
    | Skills
    |--------------------------------------------------------------------------
    */

    allRequiredSkills() {
        let projectSkills = this.skills || [];

        let skills = this.positionsRequiredSkills().concat(
            projectSkills
        );

        return TB.values(
            TB.keyBy(skills, 'id')
        );
    }

    positionsRequiredSkills() {
        if (!this.positions) {
            return [];
        }

        let positionsSkills = [];
        for (let position of this.positions) {
            if (!position.skills) {
                continue;
            }

            positionsSkills = positionsSkills.concat(
                position.skills
            );
        }

        return TB.values(
            TB.keyBy(positionsSkills, 'id')
        );
    }

    /*
    |--------------------------------------------------------------------------
    | Talent Sorting Selection
    |--------------------------------------------------------------------------
    */

    static CachedSortingSelectionKey = 'ProjectSorting';

    static cachedMatchSorting() {
        let allSelections = localStorage.getItem(
            this.CachedSortingSelectionKey
        );
        if (!allSelections) {
            return {};
        }

        allSelections = JSON.parse(allSelections);
        if (!allSelections) {
            return {};
        }

        return allSelections;
    }

    cachedMatchSort() {
        let allSelections = this.constructor.cachedMatchSorting();

        return allSelections[this.id];
    }

    matchSort() {
        let selection = this.cachedMatchSort();

        let availableOptions = TB.keys(
            this.talentMatchType().matchSortingOptions()
        );

        if (selection && TB.includes(availableOptions, selection)) {
            return selection;
        }

        let defaultOption = 'best_match';
        // this.talentMatchType().defaultSortingOptionFor(
        //   		this
        //   	);
        if (defaultOption && TB.includes(availableOptions, defaultOption)) {
            return defaultOption;
        }

        return availableOptions[0];
    }

    setMatchSort(sortBy) {
        let allSelections = this.constructor.cachedMatchSorting();

        allSelections[this.id] = sortBy;

        localStorage.setItem(
            this.constructor.CachedSortingSelectionKey,
            JSON.stringify(allSelections)
        );

        return sortBy;
    }


    visibilitySettings() {
        let fields = [
            'visibility_setting_location',
            'visibility_setting_hired',
            'visibility_setting_favorites',
            'visibility_setting_invited',
            // 'visible_regions',
            'visibility_setting_all_talent',
            'visible_talent_pools',
            'posts_on_talent_job_board'
        ]

        let settings = {...(TB.pick(this, fields))};

        settings.visible_talent_pools = settings.visible_talent_pools || [];

        if (!settings.visible_regions) {
            settings.visible_regions = []
        }
        if (parseInt(settings.visibility_setting_location) === TB.locationRegionalSetting()) {
            let availableRegions = TB.auth().user()?.client_organization?.regions || [];
            if (availableRegions?.length && !settings.visible_regions?.length) {
                settings.visible_regions = [TB.first(availableRegions)];
            }
        }
        if (!settings.visibility_setting_location) {
            settings.visibility_setting_location = TB.locationGlobalSetting();
        }
        if (settings.visibility_setting_location !== TB.locationRegionalSetting()) {
            settings.visible_regions = [];
        }

        if(!settings.visibility_setting_hired) {
            settings.visibility_setting_hired = 0;
        }
        if(!settings.visibility_setting_favorites) {
            settings.visibility_setting_favorites = 0;
        }
        if(!settings.visibility_setting_invited) {
            settings.visibility_setting_invited = 0;
        }
        if (!settings?.visible_talent_pools?.length) {
            settings.visible_talent_pools = []
        }
        settings.visibility_setting_all_talent = false;
        return settings
    }

    /*
    * Expense Line Items helper functions
    */
    expenseLineItems() {
        return TB.map(this.contract_line_items || [], item => ({
            ...item,
            clientBillable: item.billable_amount || 0,
            talentReimbursable: item.is_reimbursable
                ? item.amount
                : 0
        }))
    }

    // outOfPocketExpenseLineItems() {
    //     return TB.filter(this.expenseLineItems(), item => item.type !== 'Admin Fee' && item.type !== 'Background Check')
    // }
    //
    // totalMarkupCostOfBillableOutOfPocketExpenses() {
    //     let expenses = TB.filter(this.outOfPocketExpenseLineItems(), ['is_billable', true]);
    //     // console.log('totalBillableOutOfPocketExpenses', expenses)
    //     return TB.sumBy(expenses, item => {
    //         if (!TB.isDefined(item.percent_markup)) {
    //             return 0
    //         }
    //         return (item.amount * (1 + parseFloat(item.percent_markup || 0))) - item.amount;
    //     })
    // }
    //
    // totalCostOfBillableOutOfPocketExpenses() {
    //     let expenses = TB.filter(this.outOfPocketExpenseLineItems(), ['is_billable', true]);
    //     // console.log('totalBillableOutOfPocketExpenses', expenses)
    //     return TB.sumBy(expenses, item => {
    //         return parseFloat(item.amount)
    //     })
    // }
    // totalBillableOutOfPocketExpenses() {
    //     let expenses = TB.filter(this.outOfPocketExpenseLineItems(), ['is_billable', true]);
    //     // console.log('totalBillableOutOfPocketExpenses', expenses)
    //     return TB.sumBy(expenses, item => {
    //         if (!TB.isDefined(item.percent_markup)) {
    //             return parseFloat(item.amount)
    //         }
    //         return item.amount * (1 + parseFloat(item.percent_markup || 0));
    //     })
    // }
    //
    // totalNonBillableOutOfPocketExpenses() {
    //     let expenses = TB.filter(this.outOfPocketExpenseLineItems(), ['is_billable', false]);
    //     // console.log('totalNonBillableOutOfPocketExpenses', expenses)
    //     return TB.sumBy(expenses, item => parseFloat(item.amount))
    // }
    //
    // totalOutOfPocketExpenses() {
    //     return this.totalBillableOutOfPocketExpenses() + this.totalNonBillableOutOfPocketExpenses()
    // }
    //
    // adminFeeExpenseLineItems() {
    //     return TB.filter(this.expenseLineItems(), item => item.type === 'Admin Fee' || item.type === 'Background Check')
    // }
    //
    // totalMarkupCostOfBillableAdminFeeExpenses() {
    //     let expenses = TB.filter(this.adminFeeExpenseLineItems(), ['is_billable', true]);
    //     // console.log('totalMarkupCostOfBillableAdminFeeExpenses', expenses)
    //     return TB.sumBy(expenses, item => {
    //         if (!TB.isDefined(item.percent_markup)) {
    //             return 0
    //         }
    //         return (item.amount * (1 + parseFloat(item.percent_markup || 0))) - item.amount;
    //     })
    // }
    //
    // totalCostOfBillableAdminFeeExpenses() {
    //     let expenses = TB.filter(this.adminFeeExpenseLineItems(), ['is_billable', true]);
    //     // console.log('totalCostOfBillableAdminFeeExpenses', expenses)
    //     return TB.sumBy(expenses, item => {
    //         return parseFloat(item.amount)
    //     })
    // }
    //
    // totalBillableAdminFeeExpenses() {
    //     let expenses = TB.filter(this.adminFeeExpenseLineItems(), ['is_billable', true]);
    //     return TB.sumBy(expenses, item => {
    //         // if (!TB.isDefined(item.percent_markup)) {
    //         //     return parseFloat(item.amount)
    //         // }
    //         return item.amount * (1 + parseFloat(item.percent_markup || 0));
    //     })
    // }
    //
    // totalNonBillableAdminFeeExpenses() {
    //     let expenses = TB.filter(this.adminFeeExpenseLineItems(), ['is_billable', false]);
    //     return TB.sumBy(expenses, item => parseFloat(item.amount))
    // }




    // Filter line items for non-admin users (hide non-billable expenses)
    filteredExpenseLineItemsForAuth() {
        let contractLineItems = this.expenseLineItems();

        if (!TB.auth()?.canManageClients?.()) {
            return contractLineItems;
        }

        return contractLineItems.filter(item => item.billable_amount > 0);
    }

    totalExpenseBudget() {
        return this.filteredExpenseLineItemsForAuth().reduce(
            (sum, expense) => sum + (expense.amount || 0), 0
        );
    }

    totalNonBillableExpensesFees() {
        return this.totalInternalCostProjectFees() + this.totalNonBillableProjectExpenses()
    }

    totalProjectFeesWithExpenses() {
        return (this.contract_value || 0) + this.totalBillableProjectExpenses() + this.totalBillableProjectFees()
    }

    totalDirectTalentCostWithExpenses() {
        return (this.talent_cost || 0) + this.totalTalentReimbursableExpenses()
    }

    totalTakeRateIncludingExpenses() {
        const totalDirectTalentCost = this.totalDirectTalentCostWithExpenses();
        const totalProjectNonBillableExpenses = this.totalNonBillableExpensesFees();
        const totalProjectFees = this.totalProjectFeesWithExpenses();
        return (totalDirectTalentCost + totalProjectNonBillableExpenses) > 0
            ? ((totalProjectFees - (totalDirectTalentCost + totalProjectNonBillableExpenses)) /
            (totalDirectTalentCost + totalProjectNonBillableExpenses)) * 100
            : 0;
    }

    isContractItemTypeExpense(item) {
        return this.constructor.isContractItemTypeExpense(item)
    }

    isContractItemTypeFee(item) {
        return this.constructor.isContractItemTypeFee(item)
    }
    static isContractItemTypeExpense(item) {
        return item?.type !== 'Admin Fee' && item?.type !== 'Background Check'
    }

    static isContractItemTypeFee(item) {
        return item?.type === 'Admin Fee' || item?.type === 'Background Check'
    }

    totalProjectExpenseBudget() {
        return TB.reduce(this.contract_line_items, (result, item) => {
            if (this.constructor.isContractItemTypeExpense(item)) {
                result += item.amount || 0
            }
            return result
        }, 0)
    }
    totalNonBillableProjectExpenses() {
        return TB.reduce(this.contract_line_items, (result, item) => {
            if (!item.billable_amount && this.constructor.isContractItemTypeExpense(item)) {
                result += item.amount || 0
            }
            return result
        }, 0)
    }

    totalBillableProjectExpenses() {
        return TB.reduce(this.contract_line_items, (result, item) => {
            if (this.constructor.isContractItemTypeExpense(item)) {
                result += item.billable_amount || 0
            }
            return result
        }, 0)
    }

    totalInternalCostProjectFees() {
        return TB.reduce(this.contract_line_items, (result, item) => {
            if (this.constructor.isContractItemTypeFee(item)) {
                result += item.amount || 0
            }
            return result
        }, 0)
    }

    totalBillableProjectFees() {
        return TB.reduce(this.contract_line_items, (result, item) => {
            if (this.constructor.isContractItemTypeFee(item)) {
                result += item.billable_amount || 0
            }
            return result
        }, 0)
    }

    totalTalentReimbursableExpenses() {
        return TB.reduce(this.contract_line_items, (result, item) => {
            if (this.constructor.isContractItemTypeExpense(item) && item.is_reimbursable) {
                result += item.amount || 0
            }
            return result
        }, 0)
    }

    /*
    * Source helper methods
    * */
    isHiringSourceTalentPoolReq() {
        return this.source === 'Talent Pool Req'
    }

    isHiringSourceQuickHire() {
        return this.source === 'Browse Talent'
    }

    /**
     * A recorded rehire: terms agreed off-platform with an in-network talent, entered here so
     * Wripple can act as Employer of Record. Never went through a proposal round.
     */
    isHiringSourceRehire() {
        return this.source === 'Rehire'
    }

    isHiringSourceQuickHireOpenToTalent() {
        return !this.isHiringSourceQuickHire() || !this.is_direct_hire
    }

    isHiringSourceWizard() {
        return !this.source || this.source === 'Wizard'
    }

    byoHiringSourceLabel() {
        // if (this.isHiringSourceWizard() || !this.isHiringSourceQuickHireOpenToTalent()) {
        //     return 'Hire by Open Positions'
        // }
        if (this.isHiringSourceRehire()) {
            return 'Rehire - Pre-Agreed'
        }
        if (this.isHiringSourceQuickHire()) {
            return this.isHiringSourceQuickHireOpenToTalent() ? 'Quick Hire - Open To Talent' : 'Quick Hire';
        }
        if (this.isHiringSourceTalentPoolReq()) {
            return 'Talent Pool Open Req'
        }
        return 'Hire by Open Positions'
    }

    static normalize(props) {
        if (props.type) props.type = parseInt(props.type)
        if (this.isBYOType(this.typeNameFor(props.type)) && !TB.isDefined(props.posts_on_talent_job_board)) {
            props.posts_on_talent_job_board = true;
        }
        if (this.isServiceType(this.typeNameFor(props.type))) {
            // let levels = TB.keys(laravel.talent_experience_levels);
            // if (levels?.length > 0 && levels[1]) {
            //     props.min_score = levels[1]
            // }
            if (props.assigned_team_candidate) {
                let job_candidate = {...props.assigned_team_candidate};
                delete job_candidate.team;
                let team = {...props.assigned_team_candidate.team, job_candidate}
                props.assigned_team_candidate = Team.normalizeScope(team, props);
            }
        }
        if (props.positions?.length) {

            if (props.positions) {
                props.positions = props.positions.map(position => {
                    position.change_order_items = TB.map([...(position.change_order_items || [])], order => {
                        if (!order.position_id) {
                            order.position_id = position.id;
                        }
                        return order;
                    })
                    let positionProps = {
                        contract_type: props.contract_type,
                        project_id: props.id,
                        source: props.source,
                        started_at: position.started_at || props.anticipated_started_at,
                        ended_at: position.ended_at || (props.anticipated_ended_at),
                        percent_markup: props.percent_markup,
                        ...position
                    };
                    if (Project.contractTypeNameFor(props.contract_type) === ContractType.FixedRetainer && !position.payout_frequency) {
                        positionProps.payout_frequency = 'weekly'
                    }
                    return ProjectPosition.make(positionProps)
                });
                if (props.change_orders) {

                    let changeOrderItems = TB.groupBy(TB.map(TB.flatMap(props.positions, 'change_order_items')), 'change_order.id');
                    props.change_orders = TB.map(props.change_orders, order => {
                        return ChangeOrder.make({
                            ...order,
                            items: changeOrderItems[order.id]
                        })
                    })
                }
            }
        }

        if (props.delivery_date && typeof props.delivery_date === 'string') {
            props.delivery_date = new Date(props.delivery_date)
        }
        if (props.engagement_lead?.user) {
            props.engagement_lead.user = User.make({...props.engagement_lead.user});
        }

        if (props.client_project_group && !TB.isDefined(props.client_project_group_id)) {
        	props.client_project_group_id = props.client_project_group.id;
        }

        let auth = TB.auth().user();

        if (!props.industries && auth && auth.clientOrg() && auth.clientIndustry()) {
            props.industries = [
                auth.clientIndustry()
            ]
        }
        // if (!props.location && auth && auth.clientOrg()?.location) {
        //     props.location = auth.clientOrg()?.location;
        // }
        if (props.documents?.length) {
            props.documents = Document.makeMany(props.documents);
        }
        if (props.assigned_users?.length) {
            props.assigned_users = User.makeMany(TB.orderBy(props.assigned_users, ['is_owner', user => user.id === auth.id], ['desc', 'desc']));
        }

        if (props.visibility_setting_location) {
            props.visibility_setting_location_mixed = props.visibility_setting_location > 3 ? TB.locationProximitySetting() : props.visibility_setting_location
        }else {
            props.visibility_setting_location = TB.locationGlobalSetting();
        }
        if (props.visibility_setting_hired ||
            props.visibility_setting_favorites ||
            props.visibility_setting_invited || props.visible_talent_pools?.length > 0) {
            props.visibility_setting_all_talent = false;
        }else {
            // props.visibility_setting_all_talent = true;
        }
        if (props.visible_talent_pools) {
            props.visible_talent_pools = TB.map(props.visible_talent_pools, pool => {
                if (pool?.owner) {
                    return {
                        ...pool, owner: User.make(pool.owner)
                    }
                }
                return pool
            })
            if (!props.selected_talent_pools) {
                props.selected_talent_pools = props.visible_talent_pools
            }
        }
        // console.log('normalizeAllTalent', props.visibility_setting_all_talent)


        if (!TB.isDefined(props.visibility_setting_location_regions)) {
            props.visibility_setting_location_regions = props.visible_regions?.length > 0;
        }

        if(!props.contract_line_items?.length) {
            props.contract_line_items = []
        }

        return props;
    }
}

const fetchProjectForClient = async({queryKey, signal}) => {
    const project_id = queryKey[1] || {};  // queryKey[0] is the original query key 'infinite-posts'

    return Project.fetchForClient(project_id, false,{signal})
}

export {
    fetchProjectForClient
}